var baselThemeModule;
if (
    ((function ($) {
        "use strict";
        baselThemeModule = (function () {
            var baselTheme = {
                popupEffect: "mfp-move-horizontal",
                shopLoadMoreBtn: ".basel-products-load-more.load-on-scroll",
                supports_html5_storage: !1,
                ajaxLinks: ".basel-products-shop-view a, .widget_product_categories a, .widget_layered_nav_filters a, .filters-area a, .shopify-pagination a, .basel-shopify-layered-nav a, .widget_product_tag_cloud a",
            };
            try {
                (baselTheme.supports_html5_storage = "sessionStorage" in window && null !== window.sessionStorage), window.sessionStorage.setItem("basel", "test"), window.sessionStorage.removeItem("basel");
            } catch (e) {
                baselTheme.supports_html5_storage = !1;
            }
            return {
                init: function () {
                    this.headerBanner(),
                        this.fixedHeaders(),
                        this.verticalHeader(),
                        this.splitNavHeader(),
                        this.visibleElements(),
                        this.bannersHover(),
                        this.shopcarousel(),
                        this.inscarousel(),
                        this.instagram(),
                        this.parallax(),
                        this.googleMap(),
                        this.scrollTop(),
                        this.quickViewInit(),
                        this.quickShop(),
                        this.sidebarMenu(),
                        this.AJAXAddToCart(),
                        this.AJAXFormAddToCart(),
                        this.productImages(),
                        this.productImagesGallery(),
                        this.stickyDetails(),
                        this.mfpPopup(),
                        this.swatchesOnGrid(),
                        this.swatchesOnBGGrid(),
                        this.blogMasonry(),
                        this.blogLoadMore(),
                        this.productsLoadMore(),
                        this.productsTabs(),
                        this.productsGalaxyTabs(),
                        this.equalizeColumns(),
                        this.menuSetUp(),
                        this.menuOffsets(),
                        this.onePageMenu(),
                        this.mobileNavigation(),
                        this.simpleDropdown(".input-dropdown-inner_pr"),
                        this.autoloadCompare(),
                        this.wishList(),
                        this.loginWishlist(),
                        this.removeWishlist(),
                        this.compare(),
                        this.gl_save_note(),
                        this.promoPopup(),
                        this.cookiesPopup(),
                        this.productVideo(),
                        this.product360Button(),
                        this.stickyFooter(),
                        this.cartWidget(),
                        this.ajaxFilters(),
                        this.shopPageInit(),
                        this.filtersArea(),
                        this.categoriesMenu(),
                        this.searchFullScreen(),
                        this.loginTabs(),
                        this.productAccordion(),
                        this.productCompact(),
                        this.countDownTimer(),
                        this.initCountdown_page(),
                        this.mobileFastclick(),
                        this.nanoScroller(),
                        this.videoPoster(),
                        this.RTL(),
                        this.AJAXRemoveFromCart(),
                        this.shopifyQuantity(),
                        this.loginSidebar(),
                        this.checkoutIndicator(),
                        this.ExtraContent(),
                        $(window).resize(),
                        $("body").addClass("document-ready");
                },
                init_zoom: function () {
                    var e = $(".shopify-product-gallery__image"),
                        t = !1;
                    wc_single_product_params.flexslider_enabled || (e = e.first()),
                        $(e).each(function (e, o) {
                            if ($(o).find("img").attr("width") > $(".shopify-product-gallery").width()) return (t = !0), !1;
                        }),
                        t && (e.trigger("zoom.destroy"), e.zoom({ touch: !1 }));
                },
                productHover: function () {
                    $(".shopify-hover-base").each(function () {
                        var t = $(this);
                        t.imagesLoaded(function () {
                            var o = t.find(".hover-content"),
                                a = o.find(".hover-content-inner"),
                                s = o.outerHeight(),
                                i = a.outerHeight() - s;
                            o.hasClass("more-description") || (i > 30 ? (o.addClass("more-description"), o.append('<a href="#" class="more-details-btn"><span>more</a></span>')) : i > 0 && o.css("height", s + i), e(t));
                        });
                    }),
                        $("body").on("click", ".more-details-btn", function (t) {
                            t.preventDefault(), $(this).parent().addClass("show-full-description"), e($(this).parents(".shopify-hover-base"));
                        }),
                        $(window).width() < 992 &&
                            $(".shopify-hover-base").on("click", function (e) {
                                $(this).hasClass("state-hover") || (e.preventDefault(), $(".state-hover").removeClass("state-hover"), $(this).addClass("state-hover"));
                            });
                    var e = function (e) {
                        if (!e.hasClass("product-in-carousel")) {
                            var t = e.find(".fade-in-block").outerHeight();
                            e.find(".content-product-imagin").css({ marginBottom: -t }), e.addClass("hover-ready");
                        }
                    };
                    $(".product-grid-item").each(function () {
                        var e = $(this);
                        e.outerWidth() < 255 || $(window).width() <= 1024 ? e.removeClass("hover-width-big").addClass("hover-width-small") : e.removeClass("hover-width-small").addClass("hover-width-big");
                    });
                },
                loginSidebar: function () {
                    if (0 !== $(".login-form-side").length) {
                        var e = $("body");
                        $(".login-side-opener").on("click", function (e) {
                            e.preventDefault(),
                                a()
                                    ? t()
                                    : setTimeout(function () {
                                          o();
                                      }, 10);
                        }),
                            e.on("click touchstart", ".basel-close-side", function () {
                                a() && t();
                            }),
                            e.on("click", ".widget-close", function (e) {
                                e.preventDefault(), a() && t();
                            });
                        var t = function () {
                                e.removeClass("basel-login-side-opened");
                            },
                            o = function () {
                                e.addClass("basel-login-side-opened");
                            },
                            a = function () {
                                return e.hasClass("basel-login-side-opened");
                            };
                    }
                },
                headerBanner: function () {
                    var e = theme.basel_settings.header_banner_version,
                        t = (theme.basel_settings.close_banner_btn, theme.basel_settings.header_banner_enabled);
                    if ("closed" != $.cookie("basel_tb_banner_" + e) && 0 != t) {
                        var o = $(".header-banner");
                        $("body").addClass("header-banner-display"),
                            o.on("click", ".close-header-banner", function (e) {
                                e.preventDefault(), a();
                            });
                        var a = function () {
                            $("body").removeClass("header-banner-display").addClass("header-banner-hide"), $.cookie("basel_tb_banner_" + e, "closed", { expires: 60, path: "/" });
                        };
                    }
                },
                videoPoster: function () {
                    $(".basel-video-poster-wrapper").on("click", function () {
                        var e = $(this),
                            t = e.siblings("iframe"),
                            o = t.attr("src"),
                            a = o + "&autoplay=1";
                        o.indexOf("vimeo.com") + 1 && (a = o + "?autoplay=1"), t.attr("src", a), e.addClass("hidden-poster");
                    });
                },
                fixedHeaders: function () {
                    var e = function () {
                            var e = a.outerHeight();
                            return o.hasClass("sticky-navigation-only") && (e = a.find(".navigation-wrap").outerHeight()), e;
                        },
                        t = function () {
                            s.hasClass(n) || $(".header-spacing").height(e()).css("marginBottom", 40);
                        },
                        o = $("body"),
                        a = $(".main-header"),
                        s = a,
                        i = e(),
                        n = "act-scroll",
                        l = "",
                        r = 0,
                        c = a.find(".main-nav .menu>li>a");
                    if (o.hasClass("enable-sticky-header") && !o.hasClass("global-header-vertical") && 0 != a.length) {
                        var d = a.find(".site-logo").clone().html(),
                            u = a.find(".main-nav").clone().html(),
                            p = a.find(".right-column").clone().html();
                        if ($(".right-column").length > 1)
                            var h = [
                                '<div class="sticky-header header-clone mobile_nav_center">',
                                '<div class="container">',
                                '<div class="right-column one"><div class="mobile-nav-icon"><span class="basel-burger"></span></div></div>',
                                '<div class="site-logo">' + d + "</div>",
                                '<div class="main-nav site-navigation basel-navigation">' + u + "</div>",
                                '<div class="right-column">' + (p = a.find(".right-column:not(.one)").clone().html()) + "</div>",
                                "</div>",
                                "</div>",
                            ].join("");
                        else
                            h = [
                                '<div class="sticky-header header-clone">',
                                '<div class="container">',
                                '<div class="site-logo">' + d + "</div>",
                                '<div class="main-nav site-navigation basel-navigation">' + u + "</div>",
                                '<div class="right-column">' + p + "</div>",
                                "</div>",
                                "</div>",
                            ].join("");
                        if (
                            ($(".topbar-wrapp").length > 0 && (r = $(".topbar-wrapp").outerHeight()),
                            $(".header-banner").length > 0 && o.hasClass("header-banner-display") && (r += $(".header-banner").outerHeight()),
                            o.hasClass("sticky-header-real"))
                        ) {
                            var m,
                                f = $("<div/>").addClass("header-spacing");
                            a.before(f),
                                $(window).on("resize", t),
                                $(window).on("scroll", function (e) {
                                    $(this).scrollTop() > r
                                        ? s.addClass(n)
                                        : (s.removeClass(n),
                                          clearTimeout(m),
                                          (m = setTimeout(function () {
                                              t();
                                          }, 200)));
                                });
                        } else o.hasClass("sticky-header-clone") && (a.before(h), (s = $(".sticky-header")));
                        o.hasClass("basel-header-smooth") &&
                            $(window).on("scroll", function (e) {
                                var t = (120 - $(this).scrollTop()) / 2;
                                t >= 60 ? (t = 60) : t <= 30 && (t = 30), c.css({ paddingTop: t, paddingBottom: t });
                            }),
                            o.hasClass("basel-header-overlap") || o.hasClass("sticky-navigation-only"),
                            o.hasClass("sticky-header-clone") &&
                                (a
                                    .attr("class")
                                    .split(" ")
                                    .forEach(function (e) {
                                        -1 == e.indexOf("main-header") && -1 == e.indexOf("header-") && (l += " " + e);
                                    }),
                                s.addClass(l)),
                            $(window).on("scroll", function (e) {
                                $(this).scrollTop() > i + 30 ? s.addClass(n) : s.removeClass(n);
                            }),
                            o.addClass("sticky-header-prepared");
                    }
                },
                verticalHeader: function () {
                    var e = $(".header-vertical").first();
                    if (!(e.length < 1)) {
                        var t,
                            o,
                            a,
                            s,
                            i,
                            n,
                            l,
                            r,
                            c,
                            d,
                            u = 0,
                            p = 0;
                        (t = $(document.body)),
                            (o = $(window)),
                            t.is(".admin-bar") ? $("#wpadminbar").height() : 0,
                            o.on("scroll", m).on("resize", function () {
                                clearTimeout(n), (n = setTimeout(f, 500));
                            }),
                            f();
                        for (var h = 1; h < 6; h++) setTimeout(f, 100 * h);
                    }
                    function m() {
                        var n = o.scrollTop();
                        1024 > a ||
                            ((i = e.height()),
                            (r = i + e.offset().top),
                            (s = o.height()),
                            t.height(),
                            (c = s + o.scrollTop()),
                            (d = u - n),
                            (l = i - s) > 0
                                ? n > u
                                    ? (r > c && (p += d), p < -l && (!0, (p = -l)), !1)
                                    : n < u
                                    ? (e.offset().top < o.scrollTop() && (p += d), p >= 0 && (!0, (p = 0)), !1)
                                    : (r < c && (p = s - i), p >= 0 && (!0, (p = 0)))
                                : (p = 0),
                            e.css({ top: p }),
                            (u = n));
                    }
                    function f() {
                        1024 > (a = o.width()) && (!1, e.removeAttr("style")), m();
                    }
                },
                splitNavHeader: function () {
                    var e = $(".header-split");
                    if (!(e.length <= 0)) {
                        var t,
                            o = e.find(".main-nav"),
                            a = o.find(".menu > li"),
                            s = a.length,
                            i = $("body").hasClass("rtl"),
                            n = parseInt(s / 2 + 0.5 * i - 0.5),
                            l = a.eq(n),
                            r = e.find(".site-logo .basel-logo-wrap > a"),
                            c = 0,
                            d = i ? "marginLeft" : "marginRight",
                            u = 0,
                            p = function () {
                                (t = r.outerWidth()), (c = 5), (u = 0);
                                for (var e = s - 1; e >= 0; e--) {
                                    var p = a.eq(e).outerWidth();
                                    e > n ? (u += p) : (c += p);
                                }
                                var h = c - u;
                                i
                                    ? c > u
                                        ? o.find(".menu > li:first-child").css("marginRight", -h)
                                        : o.find(".menu > li:last-child").css("marginLeft", h + 5)
                                    : c > u
                                    ? o.find(".menu > li:last-child").css("marginRight", h + 5)
                                    : o.find(".menu > li:first-child").css("marginLeft", -h),
                                    l.css(d, t);
                            };
                        r.imagesLoaded(function () {
                            p(), e.addClass("menu-calculated");
                        }),
                            $(window).on("resize", p);
                    }
                },
                counterShortcode: function (e) {
                    "done" != e.attr("data-state") &&
                        e.text() == e.data("final") &&
                        e.prop("Counter", 0).animate(
                            { Counter: e.text() },
                            {
                                duration: 3e3,
                                easing: "swing",
                                step: function (t) {
                                    t >= e.data("final") && e.attr("data-state", "done"), e.text(Math.ceil(t));
                                },
                            }
                        );
                },
                visibleElements: function () {
                    $(".basel-counter .counter-value").each(function () {
                        $(this).waypoint(
                            function () {
                                baselThemeModule.counterShortcode($(this));
                            },
                            { offset: "100%" }
                        );
                    });
                },
                compare: function () {
                    var e = $("body");
                    $("a.compare");
                    e.on("click", "a.compare", function () {
                        $(this).addClass("loading");
                        var t = $(this),
                            o = t.data("pid"),
                            a = $("#compare-content"),
                            s = gl_Currency.cookie.tearead("tea-compare");
                        if ((s = null != s ? s.split(",") : new Array()).indexOf(o) < 0 && !1 === $(this).hasClass("added")) {
                            s.push(o);
                            var i = s.join(",");
                            "," == i.substring(0, 1) && (i = i.substring(1)), gl_Currency.cookie.teawrite("tea-compare", i);
                        }
                        !1 === $(this).hasClass("added") || 0 === $.trim($("#compare-content").html()).length
                            ? (a.html(" "),
                              $.ajax({
                                  url: "/pages/compare/" + s,
                                  dataType: "html",
                                  type: "GET",
                                  success: function (e) {
                                      a.html(e);
                                  },
                                  error: function (e) {
                                      console.log("ajax error");
                                  },
                                  complete: function () {
                                      t.removeClass("loading"),
                                          e.addClass("compare-opened"),
                                          $('[data-pid="' + o + '"]')
                                              .addClass("added")
                                              .html('<span class="basel-tooltip-label">' + theme.strings.added_label + "</span>" + theme.strings.added_label),
                                          baselThemeModule.gl_currency();
                                  },
                              }))
                            : (t.removeClass("loading"), e.addClass("compare-opened"), baselThemeModule.gl_currency()),
                            $(".compare").colorbox({ inline: !0, title: !1, width: "90%", height: "90%" }),
                            $(window).resize(function () {
                                $(".compare").colorbox.resize({ title: !1, width: "90%", height: "90%" });
                            });
                    }),
                        e.on("click", "#cboxClose, #cboxOverlay", function () {
                            e.removeClass("compare-opened");
                        }),
                        e.bind("keydown.cbox_close", function (t) {
                            27 === t.keyCode && (t.preventDefault(), e.removeClass("compare-opened"));
                        }),
                        e.on("click", "#compare-content .product-remove", function (e) {
                            e.preventDefault();
                            var t = $(this).attr("data-rev"),
                                o = $("#compare-content");
                            $('[data-pid="' + t + '"]')
                                .removeClass("added")
                                .html('<span class="basel-tooltip-label">' + theme.strings.compare + "</span>" + theme.strings.compare);
                            var a = decodeURI(gl_Currency.cookie.tearead("tea-compare"));
                            null != a && (a = a.split(",")),
                                (a = jQuery.grep(a, function (e) {
                                    return e != t;
                                })),
                                (a = $.trim(a)),
                                gl_Currency.cookie.teawrite("tea-compare", a),
                                $(".gl_" + t).remove(),
                                0 === a.length && o.find("tbody").html('<tr class="no-products odd"><td>' + theme.strings.no_compare + "</td></tr>");
                        });
                },
                promoPopup: function () {
                    var e = theme.basel_settings.promo_version;
                    if (!("yes" != theme.basel_settings.enable_popup || ("yes" == theme.basel_settings.promo_popup_hide_mobile && $(window).width() < 768))) {
                        console.log("init popup");
                        $(".nathan-promo-popup");
                        var t = !1,
                            o = $.cookie("basel_shown_pages");
                        if ((o || (o = 0), o < theme.basel_settings.popup_pages)) return o++, $.cookie("basel_shown_pages", o, { expires: 7, path: "/" }), !1;
                        var a = function () {
                            $(".nathan-promo-popup").length > 0 &&
                                $.magnificPopup.open({
                                    items: { src: ".nathan-promo-popup" },
                                    type: "inline",
                                    removalDelay: 400,
                                    callbacks: {
                                        beforeOpen: function () {
                                            this.st.mainClass = "basel-popup-effect";
                                        },
                                        open: function () {},
                                        close: function () {
                                            $.cookie("basel_popup_" + e, "shown", { expires: 7, path: "/" });
                                        },
                                    },
                                });
                        };
                        "shown" != $.cookie("basel_popup_" + e) &&
                            ("scroll" == theme.basel_settings.popup_event
                                ? $(window).scroll(function () {
                                      if (t) return !1;
                                      $(document).scrollTop() >= theme.basel_settings.popup_scroll && (a(), (t = !0));
                                  })
                                : setTimeout(function () {
                                      a();
                                  }, theme.basel_settings.popup_delay)),
                            $(".basel-open-popup").on("click", function () {
                                a();
                            });
                    }
                },
                productVideo: function () {
                    $(".product-video-button a").magnificPopup({ type: "iframe", mainClass: "mfp-fade", removalDelay: 160, preloader: !1, disableOn: !1, fixedContentPos: !1 });
                },
                product360Button: function () {
                    $(".product-360-button a").magnificPopup({
                        type: "inline",
                        mainClass: "mfp-fade",
                        removalDelay: 160,
                        disableOn: !1,
                        preloader: !1,
                        fixedContentPos: !1,
                        callbacks: {
                            open: function () {
                                $(window).resize();
                            },
                        },
                    });
                },
                cookiesPopup: function () {
                    var e = theme.basel_settings.cookies_version;
                    if (!("accepted" == $.cookie("basel_cookies_" + e) || $(".basel-cookies-popup").length < 1)) {
                        var t = $(".basel-cookies-popup");
                        setTimeout(function () {
                            t.addClass("popup-display"),
                                t.on("click", ".cookies-accept-btn", function (e) {
                                    e.preventDefault(), o();
                                });
                        }, 2500);
                        var o = function () {
                            t.removeClass("popup-display").addClass("popup-hide"), $.cookie("basel_cookies_" + e, "accepted", { expires: 60, path: "/" });
                        };
                    }
                },
                googleMap: function () {
                    var e = $(".google-map-container-with-content");
                    $(window).resize(function () {
                        e.css({ height: e.find(".basel-google-map.with-content").outerHeight() });
                    });
                },
                menuSetUp: function () {
                    var e = $(".basel-navigation").find("ul.menu"),
                        t = e.find(" > li"),
                        o = "item-menu-opened";
                    t.has(".sub-menu-dropdown").addClass("menu-item-has-children"),
                        e.on("click", " > .item-event-click.menu-item-has-children > a", function (e) {
                            e.preventDefault(), $(this).parent().hasClass(o) || $("." + o).removeClass(o), $(this).parent().toggleClass(o);
                        }),
                        $(document).click(function (t) {
                            var a = t.target;
                            if (
                                $("." + o).length > 0 &&
                                !$(a).is(".item-event-hover") &&
                                !$(a).parents().is(".item-event-hover") &&
                                !$(a)
                                    .parents()
                                    .is("." + o)
                            )
                                return e.find("." + o).removeClass(o), !1;
                        });
                    $(window).on("resize", function () {
                        $(window).width() <= 1024
                            ? e.find(" > .item-event-hover").each(function () {
                                  $(this).data("original-event", "hover").removeClass("item-event-hover").addClass("item-event-click");
                              })
                            : e.find(" > .item-event-click").each(function () {
                                  "hover" == $(this).data("original-event") && $(this).removeClass("item-event-click").addClass("item-event-hover");
                              });
                    });
                },
                menuOffsets: function () {
                    var e = $(window),
                        t = $(".main-header"),
                        o = $(".main-nav").find("ul.menu"),
                        a = o.find(" > li.menu-item-design-sized");
                    o.on("hover", " > li", function (e) {
                        s($(this));
                    });
                    var s = function (o) {
                        var a = o.find(" > .sub-menu-dropdown"),
                            s = $(".website-wrapper");
                        a.attr("style", "");
                        var i = a.outerWidth(),
                            n = a.offset(),
                            l = e.width(),
                            r = s.outerWidth() + s.offset().left,
                            c = $("body").hasClass("wrapper-boxed") || $("body").hasClass("wrapper-boxed-small") ? r : l;
                        if (i && n) {
                            if ($("body").hasClass("rtl") && n.left <= 0 && o.hasClass("menu-item-design-sized") && !t.hasClass("header-vertical")) {
                                var d = -n.left;
                                a.css({ right: -d - 10 });
                                o.attr("class").split(" ").join("."), o.width();
                            } else if (n.left + i >= c && o.hasClass("menu-item-design-sized") && !t.hasClass("header-vertical")) {
                                var u = n.left + i - c;
                                a.css({ left: -u - 10 });
                                o.attr("class").split(" ").join("."), o.width();
                            }
                            if (t.hasClass("header-vertical")) {
                                var p = a.offset().top + a.outerHeight(),
                                    h = e.scrollTop() + e.outerHeight();
                                p > h && a.css({ top: h - p - 10 });
                            }
                        }
                    };
                    a.each(function () {
                        s($(this)), $(this).addClass("with-offsets");
                    });
                },
                onePageMenu: function () {
                    var e = function (e) {
                            var o = $(".vc_row#" + e);
                            if (!(o.length < 1)) {
                                var a = o.offset().top;
                                $("html, body")
                                    .stop()
                                    .animate({ scrollTop: a - 150 }, 800, function () {
                                        t(e);
                                    });
                            }
                        },
                        t = function (e) {
                            $(".onepage-link").each(function () {
                                $(this).find("> a").attr("href").split("#")[1] == e && ($(".onepage-link").removeClass("current-menu-item"), $(this).addClass("current-menu-item"));
                            });
                        };
                    if (
                        ($("body").on("click", ".onepage-link > a", function (t) {
                            var o = $(this).attr("href").split("#")[1];
                            $(".gl_row#" + o).length < 1 || (t.preventDefault(), e(o), $(".basel-close-side").trigger("click"));
                        }),
                        $(".onepage-link").length > 0)
                    ) {
                        $(".entry-content > .gl_row").waypoint(
                            function () {
                                var e = $(this).attr("id");
                                t(e);
                            },
                            { offset: 0 }
                        ),
                            $(".onepage-link").removeClass("current-menu-item");
                        var o = window.location.hash.split("#")[1];
                        window.location.hash.length > 1 &&
                            setTimeout(function () {
                                e(o);
                            }, 500);
                    }
                },
                mobileNavigation: function () {
                    var e = $("body"),
                        t = $(".mobile-nav"),
                        o = $(".website-wrapper"),
                        a = $(".mobile-nav .site-mobile-menu .menu-item-has-children");
                    $(".icon-sub-menu");
                    function s() {
                        e.removeClass("act-mobile-menu"), o.removeClass("left-wrapp");
                    }
                    a.append('<span class="icon-sub-menu"></span>'),
                        t.on("click", ".icon-sub-menu", function (e) {
                            e.preventDefault();
                            $(this).closest("li");
                            $(this).parent().hasClass("opener-page")
                                ? ($(this).parent().removeClass("opener-page").find("> ul").slideUp(200),
                                  $(this).parent().removeClass("opener-page").find("> .sub-menu-dropdown >.container > ul").slideUp(200),
                                  $(this).parent().find("> .icon-sub-menu").removeClass("up-icon"))
                                : ($(this).parent().addClass("opener-page").find("> ul").slideDown(200),
                                  $(this).parent().addClass("opener-page").find(">.sub-menu-dropdown >.container > ul").slideDown(200),
                                  $(this).parent().find("> .icon-sub-menu").addClass("up-icon"));
                        }),
                        e.on("click", ".mobile-nav-icon", function () {
                            e.hasClass("act-mobile-menu") ? s() : (e.addClass("act-mobile-menu"), o.addClass("left-wrapp"));
                        }),
                        e.on("click touchstart", ".basel-close-side", function () {
                            s();
                        });
                },
                simpleDropdown: function (e) {
                    $(e).each(function () {
                        var t = $(this),
                            o = t.find("> a"),
                            a = t.find("> input"),
                            s = t.find("> ul");
                        function i() {
                            t.removeClass("dd-shown"), s.slideUp(100);
                        }
                        $(document).click(function (o) {
                            var a = o.target;
                            if (t.hasClass("dd-shown") && !$(a).is(e) && !$(a).parents().is(e)) return i(), !1;
                        }),
                            o.on("click", function (o) {
                                return o.preventDefault(), t.hasClass("dd-shown") ? i() : ($(e + ".dd-shown > ul").slideUp(100), $(e + ".dd-shown").removeClass("dd-shown"), t.addClass("dd-shown"), s.slideDown(100)), !1;
                            }),
                            s.on("click", "a", function (e) {
                                e.preventDefault();
                                var t = $(this).data("val"),
                                    n = $(this).text();
                                s.find(".current-item").removeClass("current-item"),
                                    $(this).parent().addClass("current-item"),
                                    0 != t ? s.find("li:first-child").show() : 0 == t && s.find("li:first-child").hide(),
                                    $(this)
                                        .closest("form.has-categories-dropdown")
                                        .attr("action", "/search/collections/" + t),
                                    o.text(n),
                                    a.val(t),
                                    i();
                            });
                    });
                },
                equalizeColumns: function () {
                    ($.fn.basel_equlize = function (e) {
                        var t = $.extend({ child: "" }, e),
                            o = this;
                        "" != t.child && (o = this.find(t.child));
                        var a = function () {
                            var e = 0;
                            o.each(function () {
                                $(this).attr("style", ""), $(this).outerHeight() > e && (e = $(this).outerHeight());
                            }),
                                o.each(function () {
                                    $(this).css({ height: e + "px" });
                                });
                        };
                        $(window).bind("resize", function () {
                            a();
                        }),
                            setTimeout(function () {
                                a();
                            }, 200),
                            setTimeout(function () {
                                a();
                            }, 500),
                            setTimeout(function () {
                                a();
                            }, 800);
                    }),
                        $(".equal-columns").each(function () {
                            $(this).basel_equlize({ child: " [class*=col-] .product-element-top" });
                        });
                },
                blogMasonry: function () {
                    if (void 0 !== $.fn.isotope && void 0 !== $.fn.imagesLoaded) {
                        var e = $(".masonry-container");
                        e.imagesLoaded(function () {
                            e.isotope({ gutter: 0, isOriginLeft: !$("body").hasClass("rtl"), itemSelector: ".blog-design-masonry, .blog-design-mask, .masonry-item" });
                        }),
                            $(".masonry-filter").on("click", "a", function (t) {
                                t.preventDefault(), $(".masonry-filter").find(".filter-active").removeClass("filter-active"), $(this).addClass("filter-active");
                                var o = $(this).attr("data-filter");
                                e.isotope({ filter: o });
                            });
                    }
                },
                blogLoadMore: function () {
                    $(".basel-blog-load-more").on("click", function (e) {
                        e.preventDefault();
                        var t = $(this),
                            o = t.parent().siblings(".basel-blog-holder"),
                            a = $(this).attr("href");
                        t.addClass("loading"),
                            $.ajax({
                                url: a,
                                dataType: "html",
                                type: "GET",
                                success: function (e) {
                                    var a = (e = jQuery(e)).find("#tea_data_blog").html(),
                                        s = e.find("#tea_data_arrow").attr("data-status"),
                                        i = e.find("#tea_section_next").attr("href"),
                                        n = $(a);
                                    o.hasClass("masonry-container")
                                        ? (o.append(n).isotope("appended", n),
                                          o.imagesLoaded().progress(function () {
                                              o.isotope("layout");
                                          }))
                                        : o.append(a),
                                        "have-posts" == s ? t.attr("href", i) : t.hide();
                                },
                                error: function (e) {
                                    console.log("ajax error");
                                },
                                complete: function () {
                                    t.removeClass("loading");
                                },
                            });
                    });
                },
                productsLoadMore: function () {
                    var e,
                        t = !1;
                    $(".basel-products-element").each(function () {
                        var a = $(this),
                            s = a.find(".basel-products-holder");
                        if (s.hasClass("pagination-arrows") || s.hasClass("pagination-more-btn")) {
                            a.on("recalc", function () {
                                f();
                            }),
                                s.hasClass("pagination-arrows") &&
                                    $(window).resize(function () {
                                        f();
                                    });
                            var i,
                                n,
                                l,
                                r,
                                c,
                                d,
                                u,
                                p,
                                h,
                                m,
                                f = function () {
                                    var e = s.outerHeight();
                                    a.stop().css({ height: e });
                                },
                                g = $("body"),
                                b = a.find(".products-footer"),
                                v = b.find(".basel-products-load-prev"),
                                y = b.find(".basel-products-load-next"),
                                _ = a.find(".basel-products-loader"),
                                w = 50;
                            g.hasClass("rtl") && ((v = y), (y = b.find(".basel-products-load-prev"))),
                                $(window).scroll(function () {
                                    !(function () {
                                        (h = $(window).height() / 2),
                                            (m = $(window).outerWidth(!0) + 17),
                                            (u = a.outerWidth(!0) + 10),
                                            (i = $(window).scrollTop()),
                                            (n = a.offset().top - h),
                                            (l = a.offset().left - w),
                                            (r = l + u + w),
                                            (p = v.outerHeight()),
                                            (d = a.height() - 50 - p),
                                            (c = n + d),
                                            ((m <= 1047 && m >= 992) || (m <= 825 && m >= 768)) && ((l += 18), (r -= 18));
                                        (m < 768 || g.hasClass("wrapper-boxed") || g.hasClass("wrapper-boxed-small") || $(".main-header").hasClass("header-vertical")) && ((l += 51), (r -= 51));
                                        v.css({ left: l + "px" }), y.css({ left: r + "px" }), i < n || i > c ? (b.removeClass("show-arrow"), _.addClass("hidden-loader")) : (b.addClass("show-arrow"), _.removeClass("hidden-loader"));
                                    })();
                                }),
                                a.find(".basel-products-load-prev, .basel-products-load-next").on("click", function (a) {
                                    if ((a.preventDefault(), !t)) {
                                        (t = !0), clearInterval(e);
                                        var s = $(this),
                                            i = s.parent().siblings(".basel-products-holder"),
                                            n = s.parent().find(".basel-products-load-next"),
                                            l = s.parent().find(".basel-products-load-prev"),
                                            r = $(this).attr("href");
                                        o(i, r, s, function (t) {
                                            var o = (t = jQuery(t)).find("#tea_data_products").html(),
                                                a = t.find("#tea_section_previous").attr("href"),
                                                s = t.find("#tea_section_previous").attr("class"),
                                                r = t.find("#tea_section_next").attr("href"),
                                                c = t.find("#tea_section_next").attr("class");
                                            i.addClass("basel-animated-products").html(o),
                                                l.attr({ href: a, class: s }),
                                                n.attr({ href: r, class: c }),
                                                i.imagesLoaded().progress(function () {
                                                    i.parent().trigger("recalc");
                                                }),
                                                $(window).width() < 768 &&
                                                    $("html, body")
                                                        .stop()
                                                        .animate({ scrollTop: i.offset().top - 150 }, 400);
                                            var d = 0;
                                            e = setInterval(function () {
                                                i.find(".product-grid-item").eq(d).addClass("basel-animated"), d++;
                                            }, 100);
                                        });
                                    }
                                });
                        }
                    }),
                        baselThemeModule.clickOnScrollButton(baselTheme.shopLoadMoreBtn, !1),
                        $(document)
                            .off("click", ".basel-products-load-more")
                            .on("click", ".basel-products-load-more", function (e) {
                                if ((e.preventDefault(), !t)) {
                                    t = !0;
                                    var s = $(this),
                                        i = s.parent().siblings(".basel-products-holder"),
                                        n = $(this).attr("href");
                                    o(i, n, s, function (e) {
                                        var t = (e = jQuery(e)).find("#tea_data_products").html(),
                                            o = e.find("#shopify_result_count").html(),
                                            n = e.find("#tea_data_arrow").attr("data-status"),
                                            l = e.find("#tea_section_next").attr("href");
                                        i.hasClass("grid-masonry") ? a(i, t) : i.append(t),
                                            $(".shopify-result-count").length > 0 && $(".shopify-result-count").text(o),
                                            i.imagesLoaded().progress(function () {
                                                baselThemeModule.clickOnScrollButton(baselTheme.shopLoadMoreBtn, !0);
                                            }),
                                            "have-posts" == n ? s.attr("href", l) : s.hide().remove();
                                    });
                                }
                            });
                    var o = function (e, o, a, s) {
                            e.addClass("loading").parent().addClass("element-loading"),
                                a.addClass("loading"),
                                $.ajax({
                                    dataType: "html",
                                    type: "GET",
                                    url: o,
                                    success: function (e) {
                                        s(e);
                                    },
                                    error: function (e) {
                                        console.log("ajax error");
                                    },
                                    complete: function () {
                                        baselThemeModule.countDownTimer(),
                                            baselThemeModule.gl_productreviews(),
                                            //new Yotpo.API(yotpo).refreshWidgets(),
                                            baselThemeModule.autoloadCompare(),
                                            e.removeClass("loading").parent().removeClass("element-loading"),
                                            a.removeClass("loading"),
                                            e.hasClass("equal-columns") && e.basel_equlize({ child: "> [class*=col-] .product-element-top" }),
                                            baselThemeModule.gl_currency(),
                                            (t = !1);
                                    },
                                });
                        },
                        a = function (e, t) {
                            t = $(t);
                            e.append(t).isotope("appended", t),
                                e.isotope("layout"),
                                setTimeout(function () {
                                    e.isotope("layout");
                                }, 100),
                                e.imagesLoaded().progress(function () {
                                    e.isotope("layout");
                                });
                        };
                },
                clickOnScrollButton: function (e, t) {
                    if ("function" == typeof $.waypoints) {
                        var o = $(e);
                        t && o.waypoint("destroy"),
                            o.waypoint(
                                function () {
                                    o.trigger("click");
                                },
                                { offset: "100%" }
                            );
                    }
                },
                productsGalaxyTabs: function () {
                    $("body").on("click", "ul.gl_tta-tabs-list li a, ul.tabs li a", function (e) {
                        e.preventDefault();
                        var t = $(this),
                            o = t.closest(".tab-collection, .shopify-tabs");
                        o.find("ul.gl_tta-tabs-list, ul.tabs").find("li").removeClass("gl_active"),
                            o.find(".gl_tta-panel, .panel:not(.panel .panel)").removeClass("gl_active"),
                            t.closest("li").addClass("gl_active"),
                            o.find(t.attr("href")).addClass("gl_active");
                    });
                },
                productsTabs: function () {
                    $(".basel-products-tabs").each(function () {
                        var t = $(this),
                            o = t.find(".basel-tab-content"),
                            a = t.find(".products_nt_ajax"),
                            s = [];
                        console.log(a),
                            console.log($(a).length),
                            t.find(".products-tabs-title li").on("click", function (t) {
                                var a = $(".oms-flex-grid").length;
                                t.preventDefault();
                                var i = $(this),
                                    n = i.data("atts"),
                                    l = i.index();
                                e(n, l, o, i, s, function (e) {
                                    o.html(e), baselThemeModule.shopMasonry(), baselThemeModule.productsLoadMore(), 1 == a && $(".products_nt_ajax").addClass("oms-flex-grid");
                                });
                            });
                        var i = t.find(".tabs-navigation-wrapper"),
                            n = i.find("ul");
                        i.on("click", ".open-title-menu", function () {
                            var e = $(this);
                            n.hasClass("list-shown")
                                ? (e.removeClass("toggle-active"), n.removeClass("list-shown"))
                                : (e.addClass("toggle-active"),
                                  n.addClass("list-shown"),
                                  setTimeout(function () {
                                      $("body").one("click", function (t) {
                                          var o = t.target;
                                          if (!$(o).is(".tabs-navigation-wrapper") && !$(o).parents().is(".tabs-navigation-wrapper")) return e.removeClass("toggle-active"), n.removeClass("list-shown"), !1;
                                      });
                                  }, 10));
                        }).on("click", "li", function () {
                            var e = i.find(".open-title-menu"),
                                t = $(this).text();
                            n.hasClass("list-shown") && (e.removeClass("toggle-active").text(t), n.removeClass("list-shown"));
                        });
                    });
                    var e = function (e, t, o, a, s, i) {
                        a.parent().find(".active-tab-title").removeClass("active-tab-title"),
                            a.addClass("active-tab-title"),
                            o.addClass("loading").parent().addClass("element-loading"),
                            a.addClass("loading"),
                            $.ajax({
                                dataType: "html",
                                type: "GET",
                                url: e,
                                success: function (e) {
                                    i(e);
                                },
                                error: function (e) {
                                    console.log("ajax error");
                                },
                                complete: function () {
                                    baselThemeModule.countDownTimer(),
                                        baselThemeModule.gl_productreviews(),
                                        //new Yotpo.API(yotpo).refreshWidgets(),
                                        baselThemeModule.autoloadCompare(),
                                        o.removeClass("loading").parent().removeClass("element-loading"),
                                        a.removeClass("loading"),
                                        baselThemeModule.gl_currency();
                                },
                            });
                    };
                },
                shopMasonry: function () {
                    if (void 0 !== $.fn.isotope && void 0 !== $.fn.imagesLoaded) {
                        var e = $(".elements-grid.grid-masonry");
                        e.imagesLoaded(function () {
                            e.isotope({ isOriginLeft: !$("body").hasClass("rtl"), itemSelector: ".category-grid-item, .product-grid-item" });
                        }),
                            $(window).resize(function () {
                                $(".categories-masonry").each(function (e) {
                                    var t = $(this),
                                        o = t.hasClass("categories-style-masonry") ? ".category-grid-item" : ".col-md-3.category-grid-item";
                                    t.imagesLoaded(function () {
                                        t.isotope({ resizable: !1, isOriginLeft: !$("body").hasClass("rtl"), layoutMode: "packery", packery: { gutter: 0, columnWidth: o }, itemSelector: ".category-grid-item" });
                                    });
                                });
                            });
                    }
                },
                collectionMasonry: function () {
                    if (void 0 !== $.fn.isotope && void 0 !== $.fn.imagesLoaded) {
                        var e = $(".elements-grid.grid-masonry");
                        e.imagesLoaded(function () {
                            e.isotope({ isOriginLeft: !$("body").hasClass("rtl"), itemSelector: ".category-grid-item, .product-grid-item", layoutMode: "fitRows" });
                        });
                    }
                },
                shopcarousel: function () {
                    void 0 !== $.fn.owlCarousel &&
                        void 0 !== $.fn.imagesLoaded &&
                        $(".gl_carousel_data").each(function (e) {
                            var t = $(this).data("items"),
                                o = $(this).data("nav"),
                                a = $(this).data("dots"),
                                s = ($(this).data("medium"), $(this).data("small")),
                                i = $(this).data("time"),
                                n = $(this).data("loop"),
                                l = $(this).data("autoplay"),
                                r = $(this).data("autoheight"),
                                c = {
                                    rtl: $("body").hasClass("rtl"),
                                    items: t,
                                    responsive: { 979: { items: t }, 768: { items: 3 }, 479: { items: 3 }, 0: { items: void 0 === s ? 2 : s } },
                                    autoplay: l,
                                    autoplayTimeout: i,
                                    dots: a,
                                    nav: o,
                                    autoHeight: void 0 !== r && r,
                                    slideBy: "page",
                                    navText: !1,
                                    loop: n,
                                    onRefreshed: function () {
                                        $(window).resize();
                                    },
                                };
                            $(this).owlCarousel(c);
                        });
                },
                instagram: function () {
                    $(".gl_instagram").each(function (e) {
                        var t = $(this),
                            o = t.data("username"),
                            a = t.data("getby"),
                            s = t.data("limit"),
                            i = t.data("target"),
                            n = (t.data("size"), t.find(".instagram-pics"));
                        "2" == a && (o = t.data("accesstoken")),
                            "2" == a
                                ? $.ajax({
                                      url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + o + "&count=" + s,
                                      type: "GET",
                                      dataType: "jsonp",
                                      success: function (e) {
                                          var t = e.data,
                                              o = "";
                                          $.each(t, function (e, t) {
                                              var a = t.images.thumbnail.url,
                                                  s = t.images.low_resolution.url,
                                                  n = t.images.standard_resolution.url;
                                              t.user.full_name;
                                              o +=
                                                  '<li><a href="' +
                                                  t.link +
                                                  '" target="' +
                                                  i +
                                                  '"></a><div class="wrapp-pics jas-pr-image-link nt_bg_lz lazyload" data-bgset="' +
                                                  a +
                                                  " 150w," +
                                                  s +
                                                  " 320w," +
                                                  n +
                                                  ' 640w" data-parent-fit="cover"><div class="hover-mask"></div></div></li>';
                                          }),
                                              n.html(o);
                                      },
                                      error: function (e) {
                                          console.log("ajax error");
                                      },
                                      complete: function () {
                                          baselThemeModule.ntInscarousel();
                                      },
                                  })
                                : $.ajax({
                                      url: "https://api.teathemes.net/instagram?username=" + o,
                                      type: "GET",
                                      dataType: "json",
                                      success: function (e) {
                                          var t = e.entry_data.ProfilePage[0].user.media.nodes,
                                              o = "";
                                          $.each(t, function (e, t) {
                                              if (e >= s) return 0;
                                              var a = t.thumbnail_resources[0].src,
                                                  n = (t.thumbnail_resources[1].src, t.thumbnail_resources[2].src),
                                                  l = (t.thumbnail_resources[3].src, t.thumbnail_resources[4].src);
                                              o +=
                                                  '<li><a href="//instagram.com/p/' +
                                                  t.code +
                                                  '" target="' +
                                                  i +
                                                  '"></a><div class="wrapp-pics jas-pr-image-link nt_bg_lz lazyload" data-bgset="' +
                                                  a +
                                                  " 150w," +
                                                  n +
                                                  " 320w," +
                                                  l +
                                                  ' 640w" data-parent-fit="cover"><div class="hover-mask"></div></div></li>';
                                          }),
                                              n.html(o);
                                      },
                                      error: function (e) {
                                          console.log("ajax error");
                                      },
                                      complete: function () {
                                          baselThemeModule.ntInscarousel();
                                      },
                                  });
                    });
                },
                inscarousel: function () {
                    void 0 !== $.fn.owlCarousel &&
                        void 0 !== $.fn.imagesLoaded &&
                        $(".ins-owl-carousel").each(function (e) {
                            var t = $(this).data("items"),
                                o = $(this).data("nav"),
                                a = $(this).data("dots"),
                                s = $(this).data("medium"),
                                i = $(this).data("small"),
                                n = ($(this).data("exsmall"), $(this).data("time")),
                                l = $(this).data("dottime"),
                                r = $(this).data("loop"),
                                c = $(this).data("autoplay"),
                                d = $(this).data("animateout"),
                                u = {
                                    rtl: $("body").hasClass("rtl"),
                                    items: t,
                                    responsive: { 979: { items: t }, 768: { items: s }, 479: { items: i }, 0: { items: i } },
                                    animateOut: d,
                                    autoplay: c,
                                    autoplayTimeout: n,
                                    dotsSpeed: l,
                                    dots: a,
                                    nav: o,
                                    autoHeight: !0,
                                    slideBy: "page",
                                    navText: !1,
                                    loop: r,
                                    onRefreshed: function () {
                                        $(window).resize();
                                    },
                                };
                            $(this).owlCarousel(u);
                        });
                },
                ntInscarousel: function () {
                    void 0 !== $.fn.owlCarousel &&
                        void 0 !== $.fn.imagesLoaded &&
                        $(".nt-ins-owl-carousel").each(function (e) {
                            var t = $(this).data("items"),
                                o = $(this).data("nav"),
                                a = $(this).data("dots"),
                                s = $(this).data("medium"),
                                i = $(this).data("small"),
                                n = ($(this).data("exsmall"), $(this).data("time")),
                                l = $(this).data("loop"),
                                r = $(this).data("autoplay"),
                                c = {
                                    rtl: $("body").hasClass("rtl"),
                                    items: t,
                                    responsive: { 979: { items: t }, 768: { items: s }, 479: { items: i }, 0: { items: i } },
                                    autoplay: r,
                                    autoplayTimeout: n,
                                    dots: a,
                                    nav: o,
                                    autoHeight: !1,
                                    slideBy: "page",
                                    navText: !1,
                                    loop: l,
                                    onRefreshed: function () {
                                        $(window).resize();
                                    },
                                };
                            $(this).addClass("owl-carousel"), $(this).owlCarousel(c);
                        });
                },
                sidebarMenu: function () {
                    var e = $(".widget_nav_mega_menu").height(),
                        t = $(".categories-menu-dropdown").height(),
                        o = $(".widget_nav_mega_menu ul > li.menu-item-design-sized > .sub-menu-dropdown, .widget_nav_mega_menu ul > li.menu-item-design-full-width > .sub-menu-dropdown"),
                        a = $(".categories-menu-dropdown ul > li.menu-item-design-sized > .sub-menu-dropdown, .categories-menu-dropdown ul > li.menu-item-design-full-width > .sub-menu-dropdown");
                    o.css("min-height", e + "px"), a.css("min-height", t + "px");
                },
                productImages: function () {
                    var e = $(".shopify-product-gallery"),
                        t = $(".shopify-product-gallery__wrapper"),
                        o = e.find(".thumbnails"),
                        a = $(".photoswipe-images"),
                        s = ".basel-show-product-gallery";
                    o.addClass("thumbnails-ready"),
                        e.hasClass("image-action-popup") && (s += ", .shopify-product-gallery__image a"),
                        e.on("click", ".shopify-product-gallery__image a", function (e) {
                            e.preventDefault();
                        }),
                        e.on("click", s, function (e) {
                            e.preventDefault(), $(this).attr("href");
                            var t = l();
                            i(n(e), t);
                        }),
                        o.on("click", ".image-link", function (e) {
                            e.preventDefault();
                        }),
                        a.each(function () {
                            var e = $(this);
                            e.on("click", "a", function (t) {
                                t.preventDefault();
                                var o = $(t.currentTarget).data("index") - 1,
                                    a = r(e, []);
                                i(o, a);
                            });
                        });
                    var i = function (e, t) {
                            var o = document.querySelectorAll(".pswp")[0];
                            $("body").hasClass("rtl") && ((e = t.length - e - 1), (t = t.reverse())), new PhotoSwipe(o, PhotoSwipeUI_Default, t, { index: e, getThumbBoundsFn: function (e) {} }).init();
                        },
                        n = function (e) {
                            return t.hasClass("owl-carousel") ? t.find(".owl-item.active").index() : $(e.currentTarget).parent().index();
                        },
                        l = function () {
                            var e = [];
                            return (
                                t.find("figure a img").each(function () {
                                    var t = $(this).data("large_image"),
                                        o = $(this).data("large_image_width"),
                                        a = $(this).data("large_image_height"),
                                        s = $(this).attr("title");
                                    e.push({ src: t, w: o, h: a, title: "yes" == theme.product_images_captions && s });
                                }),
                                e
                            );
                        },
                        r = function (e, t) {
                            var o, a, s, i;
                            return (
                                e.find("a").each(function () {
                                    (o = $(this).attr("href")), (a = $(this).data("width")), (s = $(this).data("height")), (i = $(this).attr("title")), c(t, o) || t.push({ src: o, w: a, h: s, title: i });
                                }),
                                console.log(t),
                                t
                            );
                        },
                        c = function (e, t) {
                            var o;
                            for (o = 0; o < e.length; o++) if (e[o].src == t) return !0;
                            return !1;
                        };
                    if (e.hasClass("image-action-zoom")) {
                        var d = $(".shopify-product-gallery__image img");
                        d.find("img");
                        d.each(function () {
                            var e = $(this);
                            e.attr("data-large_image_width") > $(".shopify-product-gallery__image").width() && (e.trigger("zoom.destroy"), e.closest(".shopify-product-gallery__image").zoom({ url: e.attr("data-large_image"), touch: !1 }));
                        });
                    }
                },
                productImagesGallery: function () {
                    $(".shopify-product-gallery__image:eq(0) img");
                    var e,
                        t,
                        o = $(".images .thumbnails");
                    theme.product_gallery.images_slider &&
                        ($(".shopify-product-gallery__wrapper")
                            .addClass("owl-carousel")
                            .owlCarousel({
                                rtl: $("body").hasClass("rtl"),
                                items: 1,
                                autoplay: !1,
                                dots: !0,
                                nav: !1,
                                autoheight: !0,
                                navText: !1,
                                loop: !1,
                                animateOut: "fadeOut",
                                onRefreshed: function () {
                                    $(window).resize();
                                },
                            }),
                        (e = $(".shopify-product-gallery__wrapper").owlCarousel())),
                        theme.product_gallery.thumbs_slider.enabled &&
                            theme.product_gallery.images_slider &&
                            ((t = ""),
                            $(".shopify-product-gallery__image").each(function () {
                                null != $(this).data("variant_id") && null != $(this).data("lenght")
                                    ? (t +=
                                          '<img data-variant_id="' +
                                          $(this).data("variant_id") +
                                          '" data-lenght="' +
                                          $(this).data("lenght") +
                                          '" data-one="' +
                                          $(this).data("one") +
                                          '" data-two="' +
                                          $(this).data("two") +
                                          '" data-three="' +
                                          $(this).data("three") +
                                          '" src="' +
                                          $(this).data("thumb") +
                                          '" alt="' +
                                          $(this).data("alt") +
                                          '" data-image-id="' +
                                          $(this).data("id") +
                                          '"  />')
                                    : (t += '<img src="' + $(this).data("thumb") + '" alt="' + $(this).data("alt") + '" data-image-id="' + $(this).data("id") + '"  />');
                            }),
                            o.append(t),
                            "left" == theme.product_gallery.thumbs_slider.position && jQuery(window).width() > 991
                                ? (o.slick({
                                      slidesToShow: theme.product_gallery.thumbs_slider.items.vertical_items,
                                      slidesToScroll: theme.product_gallery.thumbs_slider.items.vertical_items,
                                      vertical: !0,
                                      verticalSwiping: !0,
                                      infinite: !1,
                                  }),
                                  o.on("click", "img", function (t) {
                                      var o = $(this).index();
                                      console.log(o), e.trigger("to.owl.carousel", o);
                                  }),
                                  e.on("changed.owl.carousel", function (e) {
                                      var t = e.item.index;
                                      o.slick("slickGoTo", t), o.find(".active-thumb").removeClass("active-thumb"), o.find("img").eq(t).addClass("active-thumb");
                                  }),
                                  o.find("img").eq(0).addClass("active-thumb"))
                                : (function () {
                                      o.addClass("owl-carousel").owlCarousel({
                                          rtl: $("body").hasClass("rtl"),
                                          items: theme.product_gallery.thumbs_slider.items.desktop,
                                          responsive: {
                                              979: { items: theme.product_gallery.thumbs_slider.items.desktop },
                                              768: { items: theme.product_gallery.thumbs_slider.items.desktop_small },
                                              479: { items: theme.product_gallery.thumbs_slider.items.tablet },
                                              0: { items: theme.product_gallery.thumbs_slider.items.mobile },
                                          },
                                          dots: !0,
                                          nav: !0,
                                          navText: !1,
                                      });
                                      var t = o.owlCarousel();
                                      o.on("click", ".owl-item", function (o) {
                                          var a = $(this).index();
                                          t.trigger("to.owl.carousel", a), e.trigger("to.owl.carousel", a);
                                      }),
                                          e.on("changed.owl.carousel", function (e) {
                                              var a = e.item.index;
                                              t.trigger("to.owl.carousel", a), o.find(".active-thumb").removeClass("active-thumb"), o.find(".owl-item").eq(a).addClass("active-thumb");
                                          }),
                                          o.find(".owl-item").eq(0).addClass("active-thumb");
                                  })());
                },
                stickyDetails: function () {
                    if ($("body").hasClass("basel-product-design-sticky") && $("body").hasClass("template-product")) {
                        if ($(window).width() <= 768) var e = 90;
                        else e = 130;
                        var t,
                            o = $(".entry-summary"),
                            a = o.find(".summary-inner"),
                            s = o.width(),
                            i = $(".product-images"),
                            n = i.find(".shopify-product-gallery__wrapper a"),
                            l = $(window).height(),
                            r = i.outerHeight(),
                            c = 600,
                            d = o.outerHeight(),
                            u = $(window).scrollTop(),
                            p = i.offset().top,
                            h = o.offset().left + 15,
                            m = p + r;
                        if ($(window).width() <= 768) var f = 350 + u + e + d;
                        else f = u + e + d;
                        o.css({ height: d }),
                            $(window).resize(function () {
                                v();
                            }),
                            $(window).scroll(function () {
                                console.log("111"), b(), g();
                            }),
                            i.imagesLoaded(function () {
                                v();
                            });
                    }
                    function g() {
                        (l = $(window).height()),
                            n.each(function () {
                                (t = $(this).offset().top), u > t - l + 20 && (console.log(t), $(this).addClass("animate-images"));
                            });
                    }
                    function b() {
                        (u = $(window).scrollTop()),
                            (f = u + e + d),
                            (s = o.width()),
                            (h = o.offset().left + 15),
                            (p = i.offset().top),
                            (m = p + r),
                            s > c && (h += (s - c) / 2),
                            u + e >= p
                                ? (o.addClass("block-sticked"), a.css({ top: e, left: h, width: s, position: "fixed", transform: "translateY(-20px)" }))
                                : (o.removeClass("block-sticked"), a.css({ top: "auto", left: "auto", width: "auto", position: "relative", transform: "translateY(0px)" })),
                            f > m ? o.addClass("hide-temporary") : o.removeClass("hide-temporary");
                    }
                    function v() {
                        (l = $(window).height()), (d = o.outerHeight()), (r = i.outerHeight()), d < l - e ? o.addClass("in-viewport").removeClass("not-in-viewport") : o.removeClass("in-viewport").addClass("not-in-viewport"), b(), g();
                    }
                },
                mfpPopup: function () {
                    if (
                        ($(".gallery").magnificPopup({ delegate: " > a", type: "image", image: { verticalFit: !0 }, gallery: { enabled: !0, navigateByImgClick: !0 } }),
                        $('[data-rel="mfp"]').magnificPopup({ type: "image", image: { verticalFit: !0 }, gallery: { enabled: !1, navigateByImgClick: !1 } }),
                        $('[data-rel="mfp[projects-gallery]"]').magnificPopup({ type: "image", image: { verticalFit: !0 }, gallery: { enabled: !0, navigateByImgClick: !1 } }),
                        $(".jas-magnific-image").length > 0 &&
                            $(".jas-magnific-image").magnificPopup({
                                type: "image",
                                tLoading: '<div class="loader"><div class="loader-inner"></div></div>',
                                removalDelay: 500,
                                callbacks: {
                                    beforeOpen: function () {
                                        (this.st.image.markup = this.st.image.markup.replace("mfp-figure", "mfp-figure mfp-with-anim")), (this.st.mainClass = this.st.el.attr("data-effect"));
                                    },
                                },
                            }),
                        $("#btn_size_nt").length > 0)
                    ) {
                        document.getElementById("btn_size_nt").onclick = function () {
                            var e = document.querySelectorAll(".pswp")[0],
                                t = document.querySelector("#btn_size_nt"),
                                o = [{ src: t.dataset.src, w: t.dataset.w, h: t.dataset.h }];
                            new PhotoSwipe(e, PhotoSwipeUI_Default, o, { history: !1, focus: !1, showAnimationDuration: 0, hideAnimationDuration: 0 }).init();
                        };
                    }
                    $(document).on("click", ".mfp-img", function () {
                        var e = jQuery.magnificPopup.instance;
                        (e.st.image.verticalFit = !e.st.image.verticalFit), e.currItem.img.removeAttr("style"), e.updateSize();
                    });
                },
                addToCart: function () {
                    var e = 0;
                    if ("popup" == theme.add_to_cart_action) {
                        var t = [
                            '<div class="added-to-cart">',
                            "<p>" + theme.strings.added_to_cart + "</p>",
                            '<a href="#" class="btn btn-style-link close-popup">' + theme.strings.continue_shopping + "</a>",
                            '<a href="/cart" class="btn btn-color-primary view-cart">' + theme.strings.view_cart + "</a>",
                            "</div>",
                        ].join("");
                        $.magnificPopup.open({
                            callbacks: {
                                beforeOpen: function () {
                                    $("body").addClass("cart__popup_opend"), (this.st.mainClass = baselTheme.popupEffect + "  cart-popup-wrapper");
                                },
                                close: function () {
                                    $("body").removeClass("cart__popup_opend");
                                },
                            },
                            items: { src: '<div class="white-popup add-to-cart-popup popup-added_to_cart">' + t + "</div>", type: "inline" },
                        }),
                            $(".white-popup").on("click", ".close-popup", function (e) {
                                e.preventDefault(), $.magnificPopup.close();
                            });
                    } else
                        "popup_upsell" == theme.add_to_cart_action
                            ? $.ajax({
                                  url: "/cart/?view=upsell",
                                  dataType: "html",
                                  type: "GET",
                                  beforeSend: function () {
                                      $("body").addClass("cart__popup_opend"), $("#jas-wrapper").after('<div class="loader"><div class="loader-inner"></div></div>');
                                  },
                                  success: function (e) {
                                      $.magnificPopup.open({
                                          items: { src: '<div class="mfp-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell pr"><div id="content_cart__popup_nt">' + e + "</div></div>", type: "inline" },
                                          removalDelay: 500,
                                          callbacks: {
                                              beforeOpen: function () {
                                                  this.st.mainClass = "mfp-move-horizontal";
                                              },
                                              open: function () {
                                                  baselThemeModule.checkoutIndicator();
                                              },
                                              change: function () {},
                                              close: function () {
                                                  $("body").removeClass("cart__popup_opend"), $("#content_cart__popup_nt").empty();
                                              },
                                          },
                                      });
                                  },
                                  complete: function () {
                                      baselThemeModule.gl_currency(),
                                          window.Shopify && Shopify.StorefrontExpressButtons && nathan_settings.use_additional_checkout_buttons && Shopify.StorefrontExpressButtons.initialize(),
                                          baselThemeModule.nanoScroller(),
                                          $(".loader").remove();
                                  },
                                  error: function () {
                                      $(".loader").remove(), console.log("Quick view error");
                                  },
                              })
                            : "widget" == theme.add_to_cart_action &&
                              (clearTimeout(e),
                              $(".cart-widget-opener a").length > 0
                                  ? ($("body").hasClass("open_gl_quick_view") && $.magnificPopup.close(), $(".cart-widget-opener a").trigger("click"))
                                  : $(".shopping-cart a").length > 0
                                  ? ($(".shopping-cart .dropdown-wrap-cat").addClass("display-widget"),
                                    console.log("aa"),
                                    $("body").hasClass("open_gl_quick_view") && $.magnificPopup.close(),
                                    $(window).scrollTop() > 100 && 0 == $("body").hasClass("enable-sticky-header") && $("html, body").animate({ scrollTop: 0 }, 1e3),
                                    (e = setTimeout(function () {
                                        $(".display-widget").removeClass("display-widget");
                                    }, 3500)))
                                  : (console.log("bb"),
                                    $(".main-header .dropdown-wrap-cat").addClass("display-widget"),
                                    $("body").hasClass("open_gl_quick_view") && $.magnificPopup.close(),
                                    $(window).scrollTop() > 100 && 0 == $("body").hasClass("enable-sticky-header") && $("html, body").animate({ scrollTop: 0 }, 1e3),
                                    (e = setTimeout(function () {
                                        $(".display-widget").removeClass("display-widget");
                                    }, 3500))));
                    $("body").hasClass("open_gl_quick_view") && $("body").removeClass("open_gl_quick_view");
                },
                loginWishlist: function () {
                    "no" != theme.basel_settings.wishlist &&
                        $("body").on("click", ".nitro_wishlist_login", function (e) {
                            e.preventDefault();
                            var t = $(this);
                            t.parent().addClass("feid-in");
                            var o = [
                                '<div class="added-to-cart">',
                                "<p>" + theme.strings.info_wishlist + "</p>",
                                '<a href="#" class="btn btn-style-link close-popup">' + theme.strings.continue_shopping + "</a>",
                                '<a href="/account/login" class="btn btn-color-primary view-cart">' + theme.strings.login + "</a>",
                                "</div>",
                            ].join("");
                            $.magnificPopup.open({
                                callbacks: {
                                    beforeOpen: function () {
                                        this.st.mainClass = baselTheme.popupEffect + "  cart-popup-wrapper";
                                    },
                                    close: function () {
                                        t.parent().removeClass("feid-in");
                                    },
                                },
                                items: { src: '<div id="login-wishlist" class="gl_login-wishlist white-popup add-to-cart-popup popup-added_to_cart">' + o + "</div>", type: "inline" },
                            }),
                                $(".gl_login-wishlist").on("click", ".close-popup", function (e) {
                                    e.preventDefault(), $.magnificPopup.close();
                                });
                        });
                },
                wishList: function () {
                    "no" != theme.basel_settings.wishlist &&
                        $("body").on("click", ".gl_add_wishlist > a", function (e) {
                            e.preventDefault();
                            var t = $(this),
                                o = t.closest(".yith-wcwl-add-to-wishlist"),
                                a = o.find(".gl_add_wishlist"),
                                s = o.find(".gl_adding_wishlist"),
                                i = o.find(".gl_addedbrowse_wishlist");
                            a.hide(),
                                s.show(),
                                $.ajax({
                                    url: "https://nitro-wishlist.teathemes.net?shop=" + Shopify.shop,
                                    type: "POST",
                                    cache: !0,
                                    data: t.data(),
                                    success: function (e, t) {
                                        try {
                                            e = $.parseJSON(e);
                                        } catch (e) {}
                                        "success" == e.status && "success" == t
                                            ? (i.show(),
                                              s.hide(),
                                              a.hide(),
                                              $(".gl_count_wishlist").html(function (e, t) {
                                                  return 1 * t + 1;
                                              }))
                                            : (s.hide(), a.show(), console.log("Error: " + e.message));
                                    },
                                    error: function (e) {
                                        s.hide(),
                                            a.show(),
                                            404 == e.status
                                                ? alert("This feature is not available because there is no  Nitro Wishlist app installed. Please install Nitro Wishlist app first  when using Wishlist in Shop.")
                                                : console.log("Error: " + e.message);
                                    },
                                });
                        });
                },
                removeWishlist: function () {
                    "no" != theme.basel_settings.wishlist &&
                        $("body").on("click", ".remove_from_wishlist", function (e) {
                            e.preventDefault();
                            var t = $(this),
                                o = $(this).data("id");
                            $.ajax({
                                url: "https://nitro-wishlist.teathemes.net?shop=" + Shopify.shop,
                                type: "POST",
                                data: t.data(),
                                beforeSend: function (e) {
                                    $.blockUI({ message: null, css: { backgroundColor: "#fff", opacity: 0.6 } });
                                },
                                success: function (e, t) {
                                    try {
                                        e = $.parseJSON(e);
                                    } catch (e) {}
                                    "success" == e.status && "success" == t
                                        ? ($(".gl_count_wishlist").html(function (e, t) {
                                              return 1 * t - 1;
                                          }),
                                          $("#yith-wcwl-row-" + o).remove(),
                                          $(".wishlist_table > tbody > tr").length < 1 &&
                                              ($(".wishlist_table tbody").empty(), $(".wishlist_table tbody").append('<tr><td colspan="6" class="wishlist-empty">' + theme.strings.nowishlist + "</td>")))
                                        : console.log("Error: " + e.message);
                                },
                                error: function (e) {
                                    $(".loader").remove(), console.log("Error: " + e.message);
                                },
                                complete: function () {
                                    setTimeout(function () {
                                        $.unblockUI();
                                    }, 200);
                                },
                            });
                        });
                },
                cartWidget: function () {
                    var e = $(".cart-widget-opener"),
                        t = (e.find("a"), $("body"));
                    e.on("click", "a", function (e) {
                        e.preventDefault(),
                            s()
                                ? o()
                                : setTimeout(function () {
                                      a();
                        }, 10)
                    }),
                    e.on('keypress', 'a', function(event){
                      var keycode = (event.keyCode ? event.keyCode : event.which);
                      if(keycode == '13'){
                        event.preventDefault()
                        s() ? o() : setTimeout(function () {
                          a();
                        }, 10)
                      }
                    }),
                        t.on("click touchstart", ".basel-close-side", function () {
                            s() && o();
                        }),
                        t.on("click", ".widget-close", function (e) {
                            e.preventDefault(), s() && o();
                        });
                    var o = function () {
                            $(".website-wrapper").removeClass("basel-wrapper-shifted"), $("body").removeClass("basel-cart-opened");
                        },
                        a = function () {
                            $(".website-wrapper").addClass("basel-wrapper-shifted"), $("body").addClass("basel-cart-opened");
                          	setTimeout(function(){ $('#cart-slide').focus(); }, 1000);
                        },
                        s = function () {
                            return $("body").hasClass("basel-cart-opened");
                        };
                },
                bannersHover: function () {
                    $(".promo-banner.hover-4").panr({ sensitivity: 20, scale: !1, scaleOnHover: !0, scaleTo: 1.15, scaleDuration: 0.34, panY: !0, panX: !0, panDuration: 0.5, resetPanOnMouseLeave: !0 });
                },
                parallax: function () {
                    $(".parallax-yes").each(function () {
                        var e = $(this);
                        $(window).scroll(function () {
                            var t = "center " + -$(window).scrollTop() / e.data("speed") + "px";
                            e.css({ backgroundPosition: t });
                        });
                    }),
                        $(".basel-parallax").each(function () {
                            var e = $(this);
                            e.hasClass("spb_column") ? e.find("> .gl_column-inner").parallax("50%", 0.3) : e.parallax("50%", 0.3);
                        });
                },
                fullWidthRow: function () {
                    var e = $('[data-sp-full-width="true"]');
                    $.each(e, function (e, t) {
                        var o = $(this);
                        o.addClass("sp_hidden");
                        var a = o.next(".sp_row-full-width");
                        if ((a.length || (a = o.parent().next(".sp_row-full-width")), a.length)) {
                            var s = parseInt(o.css("margin-left"), 10),
                                i = parseInt(o.css("margin-right"), 10),
                                n = 0 - a.offset().left - s,
                                l = $(window).width();
                            if ((o.css({ position: "relative", left: n, "box-sizing": "border-box", width: $(window).width() }), !o.data("spStretchContent"))) {
                                var r = -1 * n;
                                0 > r && (r = 0);
                                var c = l - r - a.width() + s + i;
                                0 > c && (c = 0), o.css({ "padding-left": r + "px", "padding-right": c + "px" });
                            }
                            o.attr("data-sp-full-width-init", "true"), o.removeClass("sp_hidden"), $(document).trigger("sp-full-width-row-single", { el: o, offset: n, marginLeft: s, marginRight: i, elFull: a, width: l });
                        }
                    }),
                        $(document).trigger("sp-full-width-row", e);
                },
                scrollTop: function () {
                    $(window).scroll(function () {
                        $(this).scrollTop() > 100 ? $(".scrollToTop").addClass("button-show") : $(".scrollToTop").removeClass("button-show");
                    }),
                        $(".scrollToTop").click(function () {
                            return $("html, body").animate({ scrollTop: 0 }, 800), !1;
                        });
                },
                quickViewInit: function () {
                    var e = this;
                    $(document).on("click", ".open-quick-view", function (t) {
                        t.preventDefault();
                        var o = $(this).attr("data-get"),
                            a = $(this);
                        a.addClass("loading"), $("body").addClass("open_gl_quick_view"), e.quickViewLoad(o, a);
                    });
                },
                quickViewLoad: function (e, t) {
                    $.ajax({
                        url: e,
                        dataType: "html",
                        type: "GET",
                        success: function (e) {
                            $.magnificPopup.open({
                                items: { src: '<div class="mfp-with-anim white-popup popup-quick-view" id="content_quickview">' + e + "</div>", type: "inline" },
                                removalDelay: 500,
                                callbacks: {
                                    beforeOpen: function () {
                                        this.st.mainClass = baselTheme.popupEffect;
                                    },
                                    open: function () {
                                        if (
                                            ($(".product-images-slider_on")
                                                .addClass("owl-carousel")
                                                .owlCarousel({ rtl: jQuery("body").hasClass("rtl"), items: 1, dots: !1, nav: !0, animateOut: "fadeOut", navText: !1 }),
                                            baselThemeModule.initCountdown_page(),
                                            baselThemeModule.gl_currency(),
                                            baselThemeModule.autoloadCompare(),
                                            setTimeout(function () {
                                                baselThemeModule.nanoScroller();
                                            }, 300),
                                            baselThemeModule.simpleDropdown(".input-dropdown-inner_quick"),
                                            Shopify.PaymentButton.init(),
                                            $(".shopify-product-reviews-badge").length > 0 && theme.gl_productreviews)
                                        )
                                            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                                        //new Yotpo.API(yotpo).refreshWidgets();
                                    },
                                    close: function () {
                                        $("#content_quickview").empty();
                                    },
                                },
                            });
                        },
                        complete: function () {
                            t.removeClass("loading");
                        },
                        error: function () {
                            console.log("Quick view error");
                        },
                    });
                },
                quickShop: function () {
                    $(document)
                        .on("click", ".btn-quick-shop", function (e) {
                            e.preventDefault();
                            var t = $(this),
                                o = t.parents(".product"),
                                a = o.find(".quick-shop-form"),
                                s = $(this).attr("data-get");
                            t.hasClass("btn-loading") ||
                                (o.hasClass("quick-shop-loaded")
                                    ? o.addClass("quick-shop-shown")
                                    : (t.addClass("btn-loading"),
                                      o.addClass("loading-quick-shop"),
                                      $.ajax({
                                          url: s,
                                          dataType: "html",
                                          type: "GET",
                                          success: function (e) {
                                              a.append(e), "yes" == theme.basel_settings.enable_variant_simple && baselThemeModule.simpleDropdown(".input-dropdown-inner_qs"), baselThemeModule.gl_currency();
                                          },
                                          complete: function () {
                                              t.removeClass("btn-loading"), o.removeClass("loading-quick-shop"), o.addClass("quick-shop-shown quick-shop-loaded");
                                          },
                                          error: function () {
                                              console.log("Quick Shop error");
                                          },
                                      })));
                        })
                        .on("click", ".quick-shop-close", function () {
                            var e = $(this).parents(".product"),
                                t = e.find(".quick-shop-form");
                            e.removeClass("quick-shop-shown quick-shop-loaded"), t.html("");
                        });
                },
                ExtraContent: function () {
                    0 !== $(".jas-wc-help").length &&
                        $(".jas-wc-help").magnificPopup({
                            type: "inline",
                            tLoading: '<div class="loader"><div class="loader-inner"></div></div>',
                            removalDelay: 500,
                            callbacks: {
                                beforeOpen: function () {
                                    this.st.mainClass = "basel-popup-effect";
                                },
                                open: function () {
                                    $("#popup_basel #tab-1").attr("checked", "checked");
                                },
                            },
                        });
                },
                stickyFooter: function () {
                    if ($("body").hasClass("sticky-footer-on") && !($(window).width() < 991)) {
                        var e,
                            t,
                            o,
                            a = $(".footer-container"),
                            s = a.find(".main-footer, .copyrights-wrapper .container"),
                            i = a.outerHeight(),
                            n = $(".main-page-wrapper"),
                            l = $(document),
                            r = $(window),
                            c = l.outerHeight(),
                            d = r.outerHeight(),
                            u = function () {
                                n.css({ marginBottom: a.outerHeight() });
                            };
                        r.on("resize", u),
                            r.on("scroll", function () {
                                (e = l.scrollTop()),
                                    (c = l.outerHeight()),
                                    (d = r.outerHeight()),
                                    (t = c - (e + d)),
                                    (i = a.outerHeight()),
                                    (o = parseFloat(t / i).toFixed(5)),
                                    a.removeClass("footer-act-sticky"),
                                    t > i || (s.css({ opacity: 1 - o }), a.addClass("footer-act-sticky"));
                            }),
                            a.imagesLoaded(function () {
                                u();
                            });
                    }
                },
                swatchesOnGrid: function () {
                    $("body").on("click", ".jas_swatch_on_img:not(.current-swatch)", function () {
                        var e,
                            t,
                            o = $(this).data("src"),
                            a = $(this).data("dtsrc"),
                            s = $(this).data("srcset"),
                            i = $(this).data("aspectratio");
                        if (void 0 !== o) {
                            var n = $(this).parents(".product-grid-item"),
                                l = n.find("img").first(),
                                r = l.attr("data-chksrc");
                            $(this).parent().find(".current-swatch").removeClass("current-swatch"),
                                $(this).addClass("current-swatch"),
                                n.addClass("product-swatched"),
                                (t = a),
                                s,
                                (e = o) != r &&
                                    (n.addClass("loading-image"),
                                    l
                                        .attr("src", e)
                                        .attr("data-src", t)
                                        .attr("data-aspectratio", i)
                                        .removeClass("lazyautosizes lazyloaded")
                                        .addClass("lazyload lazypreload")
                                        .removeClass("lazyautosizes lazyloaded")
                                        .addClass("lazyload lazypreload")
                                        .one("load", function () {
                                            l.attr("data-chksrc", e), n.removeClass("loading-image");
                                        }));
                        }
                    });
                },
                swatchesOnBGGrid: function () {
                    $("body").on("click", ".jas_swatch_on_bg:not(.current-swatch)", function () {
                        var e = $(this).data("bgset"),
                            t = $(this).data("src"),
                            o = $(this).parents(".product-grid-item"),
                            a = o.find(".jas-pr-image-link"),
                            s = a.attr("data-chksrc");
                        $(this).parent().find(".current-swatch").removeClass("current-swatch"),
                            $(this).addClass("current-swatch"),
                            o.addClass("product-swatched"),
                            t != s &&
                                (o.addClass("loading-image"),
                                a
                                    .attr("data-bgset", e)
                                    .removeClass("lazyautosizes lazyloaded")
                                    .addClass("lazyload lazypreload")
                                    .imagesLoaded({ background: !0 }, function () {
                                        a.attr("data-chksrc", t), o.removeClass("loading-image");
                                    }));
                    });
                },
                ajaxFilters: function () {
                    if ($("body").hasClass("basel-ajax-shop-on")) {
                        var e = this;
                        $(".products");
                        $("body").on("click", ".shopify-pagination a", function (e) {
                            t();
                        }),
                            $(document).pjax(baselTheme.ajaxLinks, ".main-page-wrapper", { timeout: 5e3, fragment: ".main-page-wrapper", scrollTo: !1 }),
                            $(document).on("change", "select.orderby", function () {
                                $(".shopify-ordering");
                                var e = $(this).find(":selected").data("value");
                                $.pjax({ container: ".main-page-wrapper", timeout: 4e3, url: e, fragment: ".main-page-wrapper", scrollTo: !1 });
                            }),
                            $(document).on("pjax:error", function (e, t, o, a) {
                                console.log("pjax error " + o);
                            }),
                            $(document).on("pjax:start", function (e, t) {
                                $("body").addClass("basel-loading");
                            }),
                            $(document).on("pjax:complete", function (o, a, s) {
                                if (($("#shopify-section-promo_banner_collection .promo-banner").length > 0 && e.bannersHover(), $(".nt_filter_color .chosen").length > 0)) {
                                    var i = $(".nt_filter_color .chosen a div").attr("data-handle");
                                    $(".swatch-on-grid.jas_swatch_on_bg.bg_color_" + i).trigger("click");
                                }
                                e.gl_currency(), e.countDownTimer(), e.shopPageInit(), t(), e.gl_productreviews(), $("body").removeClass("basel-loading");
                            }),
                            $(document).on("pjax:end", function (e, t, o) {
                                $("body").removeClass("basel-loading");
                            });
                        var t = function () {
                            var e = $(".main-page-wrapper").offset().top - 100;
                            $("html, body").stop().animate({ scrollTop: e }, 400);
                        };
                    }
                },
                shopPageInit: function () {
                    this.shopMasonry(),
                        $(".products").hasClass("equal-columns") &&
                            (setTimeout(function () {
                                $(".products.equal-columns").basel_equlize({ child: " [class*=col-] .product-element-top" });
                            }, 400),
                            setTimeout(function () {
                                $(".grid-masonry").isotope("layout");
                            }, 600),
                            setTimeout(function () {
                                $(".grid-masonry").isotope("layout");
                            }, 1e3)),
                        this.categorysearch(),
                        this.ajaxSearch(),
                        this.compare(),
                        this.autoloadCompare(),
                        this.categoriesMenuBtns(),
                        this.categoriesAccordion(),
                        this.nanoScroller(),
                        baselThemeModule.clickOnScrollButton(baselTheme.shopLoadMoreBtn, !1);
                },
                backHistory: function () {
                    history.go(-1),
                        setTimeout(function () {
                            $(".filters-area").removeClass("filters-opened").stop().hide(),
                                $(".open-filters").removeClass("btn-opened"),
                                $(window).width() < 992 && ($(".basel-product-categories").removeClass("categories-opened").stop().hide(), $(".basel-show-categories").removeClass("button-open"));
                        }, 20);
                },
                categoriesMenu: function () {
                    if (!($(window).width() > 991)) {
                        $(".basel-product-categories").find("li > ul"), $(".basel-show-categories");
                        $("body").on("click", ".icon-drop-category", function () {
                            $(this).parent().find("> ul").hasClass("child-open")
                                ? $(this).removeClass("basel-act-icon").parent().find("> ul").slideUp(200).removeClass("child-open")
                                : $(this).addClass("basel-act-icon").parent().find("> ul").slideDown(200).addClass("child-open");
                        }),
                            $("body").on("click", ".basel-show-categories", function (a) {
                                a.preventDefault(), console.log("close click"), e() ? o() : t();
                            });
                        var e = function () {
                                return $(".basel-product-categories").hasClass("categories-opened");
                            },
                            t = function () {
                                $(".basel-product-categories").addClass("categories-opened").stop().slideDown(200), $(".basel-show-categories").addClass("button-open");
                            },
                            o = function () {
                                $(".basel-product-categories").removeClass("categories-opened").stop().slideUp(200), $(".basel-show-categories").removeClass("button-open");
                            };
                    }
                },
                categoriesMenuBtns: function () {
                    if (!($(window).width() > 991)) {
                        var e = $(".basel-product-categories"),
                            t = e.find("li > ul");
                        e.addClass("responsive-cateogires"), t.parent().addClass("has-sub").prepend('<span class="icon-drop-category"></span>');
                    }
                },
                categoriesAccordion: function () {
                    if ("no" != theme.categories_toggle) {
                        var e = $(".widget_product_categories").find(".product-categories"),
                            t = $('<div class="basel-cats-toggle" />');
                        e.find(".cat-parent").append(t),
                            e.on("click", ".basel-cats-toggle", function () {
                                var e = $(this),
                                    t = e.prev();
                                t.hasClass("list-shown")
                                    ? (e.removeClass("toggle-active"), t.stop().slideUp(300).removeClass("list-shown"))
                                    : (t.parent().parent().find("> li > .list-shown").slideUp().removeClass("list-shown"),
                                      t.parent().parent().find("> li > .toggle-active").removeClass("toggle-active"),
                                      e.addClass("toggle-active"),
                                      t.stop().slideDown(300).addClass("list-shown"));
                            }),
                            e.find(" > li.current-cat.cat-parent, > li.current-cat-parent").length > 0 && e.find(" > li.current-cat.cat-parent, > li.current-cat-parent").find("> .basel-cats-toggle").click();
                    }
                },
                filtersArea: function () {
                    var e = $(".filters-area");
                    $(".open-filters");
                    $("body").on("click", ".open-filters", function (e) {
                        e.preventDefault(), t() ? o() : a();
                    }),
                        $("body").on("click", baselTheme.ajaxLinks, function () {
                            t() && o();
                        });
                    var t = function () {
                            return (e = $(".filters-area")).hasClass("filters-opened");
                        },
                        o = function () {
                            (e = $(".filters-area")).removeClass("filters-opened"), e.stop().slideUp(200), $(".open-filters").removeClass("btn-opened");
                        },
                        a = function () {
                            (e = $(".filters-area")).addClass("filters-opened"),
                                e.stop().slideDown(200),
                                $(".open-filters").addClass("btn-opened"),
                                setTimeout(function () {
                                    baselThemeModule.nanoScroller();
                                }, 200);
                        };
                },
                ajaxSearch: function () {
                    if ("no" != theme.basel_settings.ajax_search && "yes" != theme.basel_settings.header_search_category) {
                        var e = null;
                        $("form.basel-ajax-search").each(function () {
                            $(this)
                                .find('input[name="q"]')
                                .attr("autocomplete", "off")
                                .bind("keyup", function () {
                                    $(".autocomplete-suggestions").html("").hide();
                                    var t = $(this).val(),
                                        o = $(this).closest("form");
                                    if ("" == t.trim()) $(".autocomplete-suggestions").hide();
                                    else {
                                        if ("yes" == theme.basel_settings.ajax_search_product) var a = "/search?type=product&q=" + t;
                                        else a = "/search?q=" + t;
                                        o.addClass("search-loading"),
                                            null != e && e.abort(),
                                            (e = jQuery.get(a + "&view=json", function (e) {
                                                $(".autocomplete-suggestions").html(e),
                                                    setTimeout(function () {
                                                        o.removeClass("search-loading");
                                                    }, 300);
                                            })),
                                            setTimeout(function () {
                                                baselThemeModule.gl_currency(), $(".autocomplete-suggestions").show();
                                            }, 1500);
                                    }
                                });
                        }),
                            $("body").bind("click", function () {
                                $(".autocomplete-suggestions").hide(), $("form#searchform").removeClass("search-loading");
                            });
                    }
                },
                categorysearch: function () {
                    if ("no" != theme.basel_settings.header_search_category) {
                        var e = null,
                            t = $("form.has-categories-dropdown"),
                            o = t.find('input[name="q"]');
                        o.attr("autocomplete", "off").bind("keyup", function () {
                            $(".autocomplete-suggestions").html("").hide();
                            var a = o.val(),
                                s = "/search/collections/" + $("#product_cat").val() + "?type=product&q=" + a;
                            "" == a.trim()
                                ? $(".autocomplete-suggestions").hide()
                                : (t.addClass("search-loading"),
                                  null != e && e.abort(),
                                  (e = jQuery.get(s + "&view=json", function (e) {
                                      $(".autocomplete-suggestions").html(e),
                                          setTimeout(function () {
                                              t.removeClass("search-loading");
                                          }, 300);
                                  })),
                                  setTimeout(function () {
                                      baselThemeModule.gl_currency(), $(".autocomplete-suggestions").show();
                                  }, 1500));
                        }),
                            $("body").bind("click", function () {
                                $(".autocomplete-suggestions").hide(), $("form#searchform").removeClass("search-loading");
                            });
                    }
                },
                searchFullScreen: function () {
                    var e = $("body"),
                        t = $(".basel-search-wrapper");
                    if (t.find(".searchform").hasClass("basel-ajax-search") || !$(".search-button").hasClass("basel-search-dropdown")) {
                        e.on("click", ".search-button > a", function (e) {
                            e.preventDefault(),
                                (t = $(".sticky-header.act-scroll").length > 0 ? $(".sticky-header .basel-search-wrapper") : $(".main-header .basel-search-wrapper")),
                                s()
                                    ? o()
                                    : setTimeout(function () {
                                          a();
                                      }, 10);
                        }),
                            e.on("click", ".basel-close-search, .main-header, .sticky-header, .topbar-wrapp, .main-page-wrapper", function (e) {
                                (!$(e.target).is(".basel-close-search") && $(e.target).closest(".basel-search-wrapper").length) || (s() && o());
                            });
                        var o = function () {
                                $("body").removeClass("basel-search-opened"), t.removeClass("search-overlap");
                            },
                            a = function () {
                                var e = theme.basel_settings.header_banner_version,
                                    a = theme.basel_settings.header_banner_enabled,
                                    i = $("#wpadminbar").outerHeight();
                                if ("closed" == $.cookie("basel_tb_banner_" + e) || 0 == a) var n = 0;
                                else n = $(".header-banner").outerHeight();
                                var l = $(".main-header").outerHeight() + i + n;
                                $(".main-header").hasClass("act-scroll") || (l += $(".topbar-wrapp").outerHeight()),
                                    $(".sticky-header").hasClass("header-clone") && $(".sticky-header").hasClass("act-scroll") && (l = $(".sticky-header").outerHeight() + i),
                                    $(".main-header").hasClass("header-menu-top") && $(".header-spacing") && (l = $(".header-spacing").outerHeight() + i),
                                    t.css("top", l),
                                    $("body").addClass("basel-search-opened"),
                                    t.addClass("search-overlap"),
                                    setTimeout(function () {
                                        t.find('input[type="text"]').focus(),
                                            $(window).one("scroll", function () {
                                                s() && o();
                                            });
                                    }, 300);
                            },
                            s = function () {
                                return $("body").hasClass("basel-search-opened");
                            };
                    }
                },
                loginTabs: function () {
                    var e = $(".basel-register-tabs"),
                        t = e.find(".basel-switch-to-register"),
                        o = (e.find(".col-login"), e.find(".col-register"), t.data("login")),
                        a = t.data("register");
                    t.click(function (t) {
                        t.preventDefault(), n() ? i() : s();
                        $(".main-page-wrapper").offset().top;
                        $(window).width() < 768 &&
                            $("html, body")
                                .stop()
                                .animate({ scrollTop: e.offset().top - 50 }, 400);
                    });
                    var s = function () {
                            e.addClass("active-register"), t.text(o);
                        },
                        i = function () {
                            e.removeClass("active-register"), t.text(a);
                        },
                        n = function () {
                            return e.hasClass("active-register");
                        };
                },
                productAccordion: function () {
                    var e = $(".tabs-layout-accordion"),
                        t = window.location.hash,
                        o = window.location.href;
                    t.toLowerCase().indexOf("comment-") >= 0 || "#reviews" === t || "#tab-reviews" === t
                        ? e.find(".tab-title-reviews").addClass("active")
                        : o.indexOf("comment-page-") > 0 || o.indexOf("cpage=") > 0
                        ? e.find(".tab-title-reviews").addClass("active")
                        : e.find(".basel-accordion-title").first().addClass("active"),
                        e.on("click", ".basel-accordion-title", function (t) {
                            t.preventDefault();
                            var o = $(this),
                                a = o.siblings(".shopify-Tabs-panel");
                            o.hasClass("active")
                                ? (o.removeClass("active"), a.stop().slideUp(300))
                                : (e.find(".basel-accordion-title").removeClass("active"), e.find(".shopify-Tabs-panel").slideUp(), o.addClass("active"), a.stop().slideDown(300)),
                                $(window).resize(),
                                setTimeout(function () {
                                    $(window).resize();
                                }, 300);
                        });
                },
                productCompact: function () {
                    $(".product-design-compact .basel-scroll").nanoScroller({ paneClass: "basel-scroll-pane", sliderClass: "basel-scroll-slider", contentClass: "basel-scroll-content", preventPageScrolling: !1 });
                },
                countDownTimer: function () {
                    $(".basel-timer").each(function () {
                        $(this).countdown($(this).data("end-date"), function (e) {
                            $(this).html(
                                e.strftime(
                                    '<span class="countdown-days">%-D <span>' +
                                        theme.basel_settings.countdown_days +
                                        '</span></span> <span class="countdown-hours">%H <span>' +
                                        theme.basel_settings.countdown_hours +
                                        '</span></span> <span class="countdown-min">%M <span>' +
                                        theme.basel_settings.countdown_mins +
                                        '</span></span> <span class="countdown-sec">%S <span>' +
                                        theme.basel_settings.countdown_sec +
                                        "</span></span>"
                                )
                            );
                        });
                    });
                },
                mobileFastclick: function () {
                    "addEventListener" in document &&
                        document.addEventListener(
                            "DOMContentLoaded",
                            function () {
                                FastClick.attach(document.body);
                            },
                            !1
                        );
                },
                nanoScroller: function () {
                    $(".basel-scroll").nanoScroller({ paneClass: "basel-scroll-pane", sliderClass: "basel-scroll-slider", contentClass: "basel-scroll-content", preventPageScrolling: !1 });
                },
                RTL: function () {
                    $("body").hasClass("rtl") &&
                        $(document).on("gl-full-width-row", function (e, t) {
                            $('[data-gl-full-width="true"]').each(function () {
                                var e = $(this),
                                    t = parseInt(e.css("left"), 10);
                                if ((e.css({ left: -t }), $(".main-header").hasClass("header-vertical"))) {
                                    var o = e.css("padding-left"),
                                        a = e.css("padding-right");
                                    e.css({ paddingLeft: a, paddingRight: o });
                                }
                            });
                        });
                },
                autoloadCompare: function () {
                    if ("no" != theme.basel_settings.compare) {
                        var e = gl_Currency.cookie.tearead("tea-compare");
                        null != e
                            ? (e = e.split(",")).map(function (e, t) {
                                  $('[data-pid="' + e + '"]')
                                      .addClass("added")
                                      .html('<span class="basel-tooltip-label">' + theme.strings.added_label + "</span>" + theme.strings.added_label);
                              })
                            : (e = new Array());
                    }
                },
                gl_currency: function () {
                    var e = gl_Currency.cookie.read();
                    null != e && e != theme.shop_currency && (console.log("currency run"), Currency.convertAll(shopCurrency, gl_Currency.cookie.read()));
                },
                gl_productreviews: function () {
                    theme.gl_productreviews && $(".spr-badge").length > 0 && $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                },
                gl_save_note: function () {
                    "yes" == theme.basel_settings.save_note &&
                        $(document.body).on("change", "#CartSpecialInstructions", function () {
                            var e = $(this).val(),
                                t = $(".widget_shopping_cart"),
                                o = $(".checkout");
                            t.addClass("removing-process"),
                                o.attr("disabled", "disabled").css("pointer-events", "none"),
                                $.ajax({
                                    type: "POST",
                                    url: "/cart/update.js",
                                    data: "note=" + baselThemeModule.attributeToString(e),
                                    dataType: "json",
                                    success: function (e) {},
                                    error: function (e, t) {
                                        baselThemeModule.onError(e, t);
                                    },
                                    complete: function () {
                                        t.removeClass("removing-process"), o.removeAttr("disabled").css("pointer-events", "auto");
                                    },
                                });
                        });
                },
                attributeToString: function (e) {
                    return "string" != typeof e && "undefined" === (e += "") && (e = ""), jQuery.trim(e);
                },
                onError: function (XMLHttpRequest, textStatus) {
                    var data = eval("(" + XMLHttpRequest.responseText + ")");
                    alert(data.message + "(" + data.status + "): " + data.description);
                },
                AJAXFormAddToCart: function () {
                    theme.use_ajax_add_to_cart &&
                        $(document).on("click", ".ajax_form_cart", function (e) {
                            e.preventDefault();
                            var t = $(this);
                            $(this).attr("disabled", "disabled").css("pointer-events", "none").addClass("loading"),
                                $.ajax({
                                    type: "POST",
                                    url: "/cart/add.js",
                                    data: t.closest("form").serialize(),
                                    dataType: "json",
                                    success: function (e) {
                                        $.get("/cart?view=json", function (e) {
                                            $(".widget_shopping_cart_content").html(e);
                                        }).always(function () {
                                            baselThemeModule.gl_currency(), window.Shopify && Shopify.StorefrontExpressButtons && nathan_settings.use_additional_checkout_buttons && Shopify.StorefrontExpressButtons.initialize();
                                        }),
                                            $.getJSON("/cart.js", function (e) {
                                                $(".cartCount").html(e.item_count), $(".basel-cart-subtotal >span").html(Shopify.formatMoney(e.total_price, theme.moneyFormat));
                                            }).always(function () {
                                                baselThemeModule.gl_currency();
                                            }),
                                            baselThemeModule.addToCart();
                                    },
                                    error: function (e, t) {
                                        baselThemeModule.onError(e, t);
                                    },
                                    complete: function () {
                                        t.removeAttr("disabled").css("pointer-events", "auto").removeClass("loading");
                                    },
                                });
                        });
                },
                AJAXAddToCart: function () {
                    $(document).on("click", ".ajax_add_to_cart", function (e) {
                        e.preventDefault();
                        var t = $(this),
                            o = t.data("pid");
                        $(this).attr("disabled", "disabled").css("pointer-events", "none").addClass("loading"),
                            $.ajax({
                                type: "POST",
                                url: "/cart/add.js",
                                data: { quantity: 1, id: o },
                                dataType: "json",
                                success: function (e) {
                                    theme.use_ajax_add_to_cart
                                        ? ($.get("/cart?view=json", function (e) {
                                              $(".widget_shopping_cart_content").html(e);
                                          }).always(function () {
                                              baselThemeModule.gl_currency(), window.Shopify && Shopify.StorefrontExpressButtons && nathan_settings.use_additional_checkout_buttons && Shopify.StorefrontExpressButtons.initialize();
                                          }),
                                          $.getJSON("/cart.js", function (e) {
                                              $(".cartCount").html(e.item_count), $(".basel-cart-subtotal >span").html(Shopify.formatMoney(e.total_price, theme.moneyFormat));
                                          }).always(function () {
                                              baselThemeModule.gl_currency();
                                          }),
                                          !1 === t.hasClass("add_compare") && baselThemeModule.addToCart(),
                                          t.removeAttr("disabled").css("pointer-events", "auto").removeClass("ajax_add_to_cart loading").addClass("added_to_cart").text(theme.strings.view_cart).attr({ href: "/cart" }))
                                        : (window.location.href = "/cart");
                                },
                                error: function (e, o) {
                                    t.removeAttr("disabled").css("pointer-events", "auto").removeClass("loading"), baselThemeModule.onError(e, o);
                                },
                            });
                    });
                },
                AJAXRemoveFromCart: function () {
                    $(document).on("click", ".widget_shopping_cart .remove", function (e) {
                        e.preventDefault();
                        var t = $(this),
                            o = $(".widget_shopping_cart"),
                            a = (t.data("remove_item"), t.data("product_id"));
                        o.addClass("removing-process"),
                            $.ajax({
                                type: "POST",
                                url: "/cart/change.js",
                                data: "quantity=0&id=" + a,
                                dataType: "json",
                                success: function (e) {
                                    $.get("/cart?view=json", function (e) {
                                        $(".widget_shopping_cart_content").html(e);
                                    }).always(function () {
                                        window.Shopify && Shopify.StorefrontExpressButtons && nathan_settings.use_additional_checkout_buttons && Shopify.StorefrontExpressButtons.initialize();
                                    }),
                                        $.getJSON("/cart.js", function (e) {
                                            $(".cartCount").html(e.item_count), $(".basel-cart-subtotal >span").html(Shopify.formatMoney(e.total_price, theme.moneyFormat));
                                        }),
                                        baselThemeModule.gl_currency();
                                },
                                error: function () {
                                    baselThemeModule.onError(XMLHttpRequest, textStatus);
                                },
                                complete: function () {
                                    o.removeClass("removing-process");
                                },
                            });
                    });
                },
                checkoutIndicator: function () {
                    "no" != nathan_settings.use_agree_checkbox &&
                        ($("body").on("click", ".nt_agree", function (e) {
                            $(this).is(":checked") ? $(this).closest(".form_nt_agree").removeClass("pe_none none_checked") : $(this).closest(".form_nt_agree").addClass("pe_none none_checked");
                        }),
                        $("body").on("click", '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .additional-checkout-buttons, .checkout', function (e) {
                            if ($(this).closest(".form_nt_agree").hasClass("nt_checkout")) {
                                if (!$(this).closest(".form_nt_agree").find(".nt_agree").is(":checked")) {
                                    $(this).closest(".form_nt_agree").addClass("none_checked");
                                    var t = ['<div class="added-to-cart">', "<p>" + nathan_settings.conditions + "</p>", "</div>"].join("");
                                    return (
                                        $.magnificPopup.open({
                                            callbacks: {
                                                beforeOpen: function () {
                                                    this.st.mainClass = "mfp-move-horizontal cart-popup-wrapper";
                                                },
                                            },
                                            items: { src: '<div class="white-popup add-to-cart-popup popup-added_to_cart nt_agree_checkout">' + t + "</div>", type: "inline" },
                                        }),
                                        $(".white-popup").on("click", ".close-popup", function (e) {
                                            e.preventDefault(), $.magnificPopup.close();
                                        }),
                                        !1
                                    );
                                }
                                $(this).addClass("btn--loader-active ").submit();
                            }
                        }));
                },
                initCountdown_page: function () {
                    $(".jas_countdow_page").each(function () {
                        var e = new Date(),
                            t = e + "",
                            o = e.getFullYear() + "/" + ("0" + (e.getMonth() + 1)).slice(-2) + "/" + ("0" + e.getDate()).slice(-2),
                            a = $(this).data("time"),
                            s = $(this).data("zone");
                        if ($(this).hasClass("nt_loop_deal") && -1 == t.indexOf(s)) {
                            var i,
                                n,
                                l = $(this).data("setttime").split(","),
                                r = e.getHours() + ("0" + e.getMinutes()).slice(-2) + ("0" + e.getSeconds()).slice(-2);
                            if (-1 != $(this).data("setttime").indexOf(",")) {
                                for (i = 0; i < l.length; i++)
                                    if (((n = l[i].replace(":", "").replace(":", "").replace(":", "").replace(":", "")), parseInt(n) >= parseInt(r))) {
                                        a = o + " " + l[i];
                                        break;
                                    }
                            } else a = o;
                        }
                        $(this)
                            .countdown(a, { elapse: !0 })
                            .on("update.countdown", function (e) {
                                var t = $(this);
                                e.elapsed
                                    ? t.html("")
                                    : t.html(
                                          e.strftime(
                                              '<div class="block"><span class="flip-top">%-D</span><br><span class="label">' +
                                                  nathan_settings.countdown_days_page +
                                                  '</span></div><div class="block"><span class="flip-top">%H</span><br><span class="label">' +
                                                  nathan_settings.countdown_hours_page +
                                                  '</span></div><div class="block"><span class="flip-top">%M</span><br><span class="label">' +
                                                  nathan_settings.countdown_mins_page +
                                                  '</span></div><div class="block"><span class="flip-top">%S</span><br><span class="label">' +
                                                  nathan_settings.countdown_sec_page +
                                                  "</span></div>"
                                          )
                                      );
                            });
                    });
                },
                progressbar: function (e) {
                    var t = function (e, t) {
                            return Math.floor(Math.random() * (t - e + 1) + e);
                        },
                        o = function (e, t) {
                            var o = (100 * t) / s;
                            t < 10 && e.find(".progressbar div:first").addClass("less-than-ten"),
                                e.find(".progressbar").addClass("active progress-striped"),
                                setTimeout(function () {
                                    e.find(".progressbar div:first").css("width", o + "%"), e.find(".progressbar").removeClass("active progress-striped");
                                }, 300);
                        },
                        a = $(e),
                        s = 60,
                        i = nathan_settings.stock_from,
                        n = nathan_settings.stock_to,
                        l = t(i, n);
                    a.html("");
                    var r = a,
                        c =
                            "<p>" +
                            nathan_settings.stock_message_first +
                            " <span id='nt_count_page' class='count'>" +
                            l +
                            "</span> " +
                            nathan_settings.stock_message_last +
                            "</p><div class='progressbar'><div style='width:100%'></div></div>";
                    r.addClass("items-count"), r.html(c + r.html()), o(r, l);
                    var d = r;
                    setTimeout(function () {
                        --l < 1 && (l = t(i, n)),
                            a.find(".count").css("background-color", nathan_settings.stock_bg_process),
                            a.find(".count").css("color", "#fff"),
                            setTimeout(function () {
                                a.find(".count").css("background-color", "#fff"), a.find(".count").css("color", nathan_settings.stock_bg_process);
                            }, 1800),
                            d.find(".count").text(l),
                            o(d, l);
                    }, 10200),
                        setInterval(function () {
                            --l < 1 && (l = t(i, n)),
                                a.find(".count").css("background-color", nathan_settings.stock_bg_process),
                                a.find(".count").css("color", "#fff"),
                                setTimeout(function () {
                                    a.find(".count").css("background-color", "#fff"), a.find(".count").css("color", nathan_settings.stock_bg_process);
                                }, 1800),
                                d.find(".count").text(l),
                                o(d, l);
                        }, 102e3);
                },
                flashSoldBar: function (e) {
                    var t = nathan_settings.flash_sold_min,
                        o = nathan_settings.flash_sold_max,
                        a = nathan_settings.flash_min_time,
                        s = nathan_settings.flash_max_time;
                    (t = Math.ceil(t)), (o = Math.floor(o)), (a = Math.ceil(a)), (s = Math.floor(s));
                    var i = Math.floor(Math.random() * (o - t + 1)) + t;
                    (i = parseInt(i)) <= t && (i = t), i > o && (i = o), jQuery(".nt_flash_total_day" + e).html(i);
                    var n = Math.floor(Math.random() * (s - a + 1)) + a;
                    (n = parseInt(n)) <= a && (n = a), n > s && (n = s), jQuery(".nt_flash_in_hour" + e).html(n);
                },
                getToday: function (e, t) {
                    var o = nathan_settings.order_dayNames.split(" "),
                        a = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
                        s = new Date(),
                        i = o[s.getDay()],
                        n = s.getDate(),
                        l = a[s.getMonth()],
                        r = s.getFullYear();
                    if (("" !== e && (s.setDate(n + e), (i = o[s.getDay()]), (n = s.getDate()), (l = a[s.getMonth()]), (r = s.getFullYear())), n < 10 && (n = "0" + n), "today" == t)) s = r + "" + l + n;
                    else {
                        var c = nathan_settings.order_date_format,
                            d = { ww: i, dd: n, mm: l, yyyy: r };
                        s = d[(c = c.split(" "))[0]] + " " + d[c[1]] + "/" + d[c[2]] + "/" + d[c[3]];
                    }
                    return s;
                },
                delivery_order: function (e) {
                    var t = $(e);
                    if (nathan_settings.enable_delivery_option && "#jas_product_delivery" == e) {
                        var o = new Date(),
                            a = new Date(),
                            s = $(".date_start_delivery").data("datestart"),
                            i = $(".shipping_delivery_option .date_end_delivery").data("dateend"),
                            n = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
                        (l = (l = nathan_settings.delivery_off_days).split(" ")), s > 1 && (s -= 1), i > 1 && (i -= 1), o.setDate(o.getDate() + s), a.setDate(a.getDate() + i);
                        do {
                            (s += 1), o.setDate(o.getDate() + 1);
                        } while ($.inArray(n[o.getDay()], l) > -1);
                        do {
                            (i += 1), a.setDate(a.getDate() + 1);
                        } while ($.inArray(n[a.getDay()], l) > -1);
                        (o = baselThemeModule.getToday(s, "")), (a = baselThemeModule.getToday(i, "")), $(".date_start_delivery").html(o), $(".shipping_delivery_option .date_end_delivery").html(a);
                    }
                    if (nathan_settings.enable_delivery_order && t.length > 0) {
                        var l;
                        (o = new Date()), (a = new Date()), (i = t.parent("div").find(".date_end_delivery").data("deliveryend")), (n = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]);
                        (l = (l = nathan_settings.delivery_off_days).split(" ")), i > 1 && (i -= 1), a.setDate(a.getDate() + i);
                        do {
                            (i += 1), a.setDate(a.getDate() + 1);
                        } while ($.inArray(n[a.getDay()], l) > -1);
                        (a = baselThemeModule.getToday(i, "")), t.siblings(".date_end_delivery").html(a);
                        var r = new Date(),
                            c = new Date(r.getFullYear() + "/" + (r.getMonth() + 1) + "/" + r.getDate() + " " + nathan_settings.delivery_cutoff),
                            d = Math.round((c - r) / 6e4);
                        d <= 0 && (c.setDate(c.getDate() + 1), (d = Math.round((c - r) / 6e4)), o.setDate(o.getDate() + 1));
                        var u = Math.floor(d / 60),
                            p = Math.floor(d % 60),
                            h = o.getFullYear() + " undefined/undefined/undefined " + u + ":" + p,
                            m = new Date(h).getTime();
                        document.getElementById(e.replace("#", "")).innerHTML = u + nathan_settings.order_hours + p + nathan_settings.order_mins;
                        var f = setInterval(function () {
                            var e = new Date().getTime();
                            m - e < 0 && clearInterval(f);
                        }, 1e3);
                    }
                },
                shopifyQuantity: function () {
                    String.prototype.getDecimals ||
                        (String.prototype.getDecimals = function () {
                            var e = ("" + this).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                            return e ? Math.max(0, (e[1] ? e[1].length : 0) - (e[2] ? +e[2] : 0)) : 0;
                        }),
                        $(document).on("change keyup", ".custom-qty, .cart__popup-qty--input", function () {
                            var e,
                                t,
                                o = $(this),
                                a = o.data("vid"),
                                s = parseInt(o.val()),
                                i = (o.data("format"), o.data("price")),
                                n = o.attr("max");
                            if (isNaN(s)) return 0;
                            (n = isNaN(parseInt(n)) ? 9999 : parseInt(n)),
                                console.log(n),
                                s > n && (console.log("xxxx" + n), o.attr("value", n).val(n)),
                                (s = s > n ? n : s) <= 0 && (o.closest("tr").remove(), o.closest("li").remove(), $(".item-" + a).remove(), o.closest(".cart__popup-item").remove()),
                                (e = function (e) {
                                    $(".total .shopify-Price-amount, .order-total .shopify-Price-amount,.cart-subtotal .shopify-Price-amount,.basel-cart-subtotal .shopify-Price-amount,#cart__popup_total").html(
                                        Shopify.formatMoney(e.total_price, theme.moneyFormat)
                                    ),
                                        o
                                            .closest("tr")
                                            .find(".product-subtotal .shopify-Price-amount")
                                            .html(Shopify.formatMoney(i * s, theme.moneyFormat)),
                                        o
                                            .closest(".cart__popup-item")
                                            .find(".cart__popup-total .shopify-Price-amount")
                                            .html(Shopify.formatMoney(i * s, theme.moneyFormat)),
                                        $(".cartCount").html(e.item_count),
                                        baselThemeModule.gl_currency(),
                                        jQuery.get("/cart?view=ship", function (e) {
                                            $(".ship_nt_wrap").html(e),
                                                setTimeout(function () {
                                                    baselThemeModule.gl_currency();
                                                }, 300);
                                        });
                                }),
                                (t = {
                                    type: "POST",
                                    url: "/cart/change.js",
                                    data: "quantity=" + s + "&id=" + a,
                                    dataType: "json",
                                    success: function (t) {
                                        "function" == typeof e && e(t);
                                    },
                                    error: function (e, t) {
                                        baselThemeModule.onError(e, t);
                                    },
                                }),
                                jQuery.ajax(t);
                        }),
                        $(document).on("click", ".cart__popup-remove>a", function (e) {
                            e.preventDefault();
                            var t = $(this).attr("data-product_id");
                            $("#" + t)
                                .find(".qty")
                                .val(0)
                                .trigger("change");
                        }),
                        $(document).on("click", ".plus, .minus", function () {
                            var e = $(this).closest(".quantity").find(".qty"),
                                t = parseFloat(e.val()),
                                o = parseFloat(e.attr("max")),
                                a = parseFloat(e.attr("min")),
                                s = e.attr("step");
                            (t && "" !== t && "NaN" !== t) || (t = 0),
                                ("" !== o && "NaN" !== o) || (o = ""),
                                ("" !== a && "NaN" !== a) || (a = 0),
                                ("any" !== s && "" !== s && void 0 !== s && "NaN" !== parseFloat(s)) || (s = 1),
                                $(this).is(".plus") ? (o && t >= o ? e.val(o) : e.val((t + parseFloat(s)).toFixed(s.getDecimals()))) : a && t <= a ? e.val(a) : t > 0 && e.val((t - parseFloat(s)).toFixed(s.getDecimals())),
                                e.trigger("change");
                        });
                },
            };
        })();
    })(jQuery),
    jQuery(document).ready(function (e) {
        if (
            (baselThemeModule.init(),
            void 0 !== e.fn.owlCarousel &&
                e(".nt_js_owl .owl-carousel:not(.owl-loaded)").length > 0 &&
                e(".nt_js_owl .owl-carousel:not(.owl-loaded)").each(function (t) {
                    var o = e(this).data("option");
                    e(this).owlCarousel(o);
                }),
            e(".nt_filter_color .chosen").length > 0)
        ) {
            var t = e(".nt_filter_color .chosen a div").attr("data-handle");
            e(".swatch-on-grid.jas_swatch_on_bg.bg_color_" + t).trigger("click");
        }
        e("body").hasClass("template-product") &&
            (nathan_settings.stock_countdown && baselThemeModule.progressbar(".jas_progress_bar_pr"),
            nathan_settings.flash_sold && baselThemeModule.flashSoldBar(""),
            (nathan_settings.enable_delivery_option || nathan_settings.enable_delivery_order) && baselThemeModule.delivery_order("#jas_product_delivery")),
            e(".menu-section .menu-item-has-children").hover(
                function () {
                    e(this).addClass("nt_hover");
                },
                function () {
                    var t = e(this);
                    timer = setTimeout(function () {
                        t.removeClass("nt_hover");
                    }, 100);
                }
            );
    }),
    jQuery(window).load(function () {
        baselThemeModule.shopMasonry();
    }),
    Shopify.designMode)
) {
    jQuery(document).on("shopify:block:select", function (e) {
        var t = e.detail.blockId,
            o = jQuery("#shopify-section-" + e.detail.sectionId);
        (o.hasClass("gl_slide_show") || o.hasClass("testimonial-section")) && sliderBlock.select(t, o), $("#shopify-section-gl-product-page-description").length > 0 && $('a[href$="#' + t + '"]').trigger("click");
    });
    var sliderBlock = {
        select: function (e, t) {
            var o = t.find(".owl-carousel"),
                a = $("#blockId_" + e).data("owl-index");
            console.log("slideIndex: " + parseInt(a)), o.trigger("to.owl.carousel", parseInt(a)), "true" == t.data("autoplay") && o.trigger("stop.owl.carousel");
        },
        deselect: function (e) {
            "true" == e.data("autoplay") && e.find(".owl-carousel").trigger("play.owl.carousel");
        },
    };
    jQuery(document)
        .on("shopify:section:load", baselThemeModule.productsGalaxyTabs)
        .on("shopify:section:unload", baselThemeModule.productsGalaxyTabs)
        .on("shopify:section:select", baselThemeModule.productsGalaxyTabs)
        .on("shopify:section:deselect", baselThemeModule.productsGalaxyTabs)
        .on("shopify:block:select", baselThemeModule.productsGalaxyTabs)
        .on("shopify:block:deselect", baselThemeModule.productsGalaxyTabs),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.verticalHeader)
            .on("shopify:section:unload", baselThemeModule.verticalHeader)
            .on("shopify:section:select", baselThemeModule.verticalHeader)
            .on("shopify:section:deselect", baselThemeModule.verticalHeader)
            .on("shopify:block:select", baselThemeModule.verticalHeader)
            .on("shopify:block:deselect", baselThemeModule.verticalHeader),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.shopcarousel)
            .on("shopify:section:unload", baselThemeModule.shopcarousel)
            .on("shopify:section:select", baselThemeModule.shopcarousel)
            .on("shopify:section:deselect", baselThemeModule.shopcarousel)
            .on("shopify:block:select", baselThemeModule.shopcarousel)
            .on("shopify:block:deselect", baselThemeModule.shopcarousel),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.splitNavHeader)
            .on("shopify:section:unload", baselThemeModule.splitNavHeader)
            .on("shopify:section:select", baselThemeModule.splitNavHeader)
            .on("shopify:section:deselect", baselThemeModule.splitNavHeader)
            .on("shopify:block:select", baselThemeModule.splitNavHeader)
            .on("shopify:block:deselect", baselThemeModule.splitNavHeader),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.quickShop)
            .on("shopify:section:unload", baselThemeModule.quickShop)
            .on("shopify:section:select", baselThemeModule.quickShop)
            .on("shopify:section:deselect", baselThemeModule.quickShop)
            .on("shopify:block:select", baselThemeModule.quickShop)
            .on("shopify:block:deselect", baselThemeModule.quickShop),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.countDownTimer)
            .on("shopify:section:unload", baselThemeModule.countDownTimer)
            .on("shopify:section:select", baselThemeModule.countDownTimer)
            .on("shopify:section:deselect", baselThemeModule.countDownTimer)
            .on("shopify:block:select", baselThemeModule.countDownTimer)
            .on("shopify:block:deselect", baselThemeModule.countDownTimer),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.menuOffsets)
            .on("shopify:section:unload", baselThemeModule.menuOffsets)
            .on("shopify:section:select", baselThemeModule.menuOffsets)
            .on("shopify:section:deselect", baselThemeModule.menuOffsets)
            .on("shopify:block:select", baselThemeModule.menuOffsets)
            .on("shopify:block:deselect", baselThemeModule.menuOffsets),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.stickyFooter)
            .on("shopify:section:unload", baselThemeModule.stickyFooter)
            .on("shopify:section:select", baselThemeModule.stickyFooter)
            .on("shopify:section:deselect", baselThemeModule.stickyFooter)
            .on("shopify:block:select", baselThemeModule.stickyFooter)
            .on("shopify:block:deselect", baselThemeModule.stickyFooter),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.productAccordion)
            .on("shopify:section:unload", baselThemeModule.productAccordion)
            .on("shopify:section:select", baselThemeModule.productAccordion)
            .on("shopify:section:deselect", baselThemeModule.productAccordion)
            .on("shopify:block:select", baselThemeModule.productAccordion)
            .on("shopify:block:deselect", baselThemeModule.productAccordion),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.productCompact)
            .on("shopify:section:unload", baselThemeModule.productCompact)
            .on("shopify:section:select", baselThemeModule.productCompact)
            .on("shopify:section:deselect", baselThemeModule.productCompact)
            .on("shopify:block:select", baselThemeModule.productCompact)
            .on("shopify:block:deselect", baselThemeModule.productCompact),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.productsTabs)
            .on("shopify:section:unload", baselThemeModule.productsTabs)
            .on("shopify:section:select", baselThemeModule.productsTabs)
            .on("shopify:section:deselect", baselThemeModule.productsTabs)
            .on("shopify:block:select", baselThemeModule.productsTabs)
            .on("shopify:block:deselect", baselThemeModule.productsTabs),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.productsLoadMore)
            .on("shopify:section:unload", baselThemeModule.productsLoadMore)
            .on("shopify:section:select", baselThemeModule.productsLoadMore)
            .on("shopify:section:deselect", baselThemeModule.productsLoadMore)
            .on("shopify:block:select", baselThemeModule.productsLoadMore)
            .on("shopify:block:deselect", baselThemeModule.productsLoadMore),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.blogLoadMore)
            .on("shopify:section:unload", baselThemeModule.blogLoadMore)
            .on("shopify:section:select", baselThemeModule.blogLoadMore)
            .on("shopify:section:deselect", baselThemeModule.blogLoadMore)
            .on("shopify:block:select", baselThemeModule.blogLoadMore)
            .on("shopify:block:deselect", baselThemeModule.blogLoadMore),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.inscarousel)
            .on("shopify:section:unload", baselThemeModule.inscarousel)
            .on("shopify:section:select", baselThemeModule.inscarousel)
            .on("shopify:section:deselect", baselThemeModule.inscarousel)
            .on("shopify:block:select", baselThemeModule.inscarousel)
            .on("shopify:block:deselect", baselThemeModule.inscarousel),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.instagram)
            .on("shopify:section:unload", baselThemeModule.instagram)
            .on("shopify:section:select", baselThemeModule.instagram)
            .on("shopify:section:deselect", baselThemeModule.instagram)
            .on("shopify:block:select", baselThemeModule.instagram)
            .on("shopify:block:deselect", baselThemeModule.instagram),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.parallax)
            .on("shopify:section:unload", baselThemeModule.parallax)
            .on("shopify:section:select", baselThemeModule.parallax)
            .on("shopify:section:deselect", baselThemeModule.parallax)
            .on("shopify:block:select", baselThemeModule.parallax)
            .on("shopify:block:deselect", baselThemeModule.parallax),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.equalizeColumns)
            .on("shopify:section:unload", baselThemeModule.equalizeColumns)
            .on("shopify:section:select", baselThemeModule.equalizeColumns)
            .on("shopify:section:deselect", baselThemeModule.equalizeColumns)
            .on("shopify:block:select", baselThemeModule.equalizeColumns)
            .on("shopify:block:deselect", baselThemeModule.equalizeColumns),
        jQuery(document)
            .on("shopify:section:load", baselThemeModule.headerBanner)
            .on("shopify:section:unload", baselThemeModule.headerBanner)
            .on("shopify:section:select", baselThemeModule.headerBanner)
            .on("shopify:section:deselect", baselThemeModule.headerBanner)
            .on("shopify:block:select", baselThemeModule.headerBanner)
            .on("shopify:block:deselect", baselThemeModule.headerBanner);
}